import React, { useState, useEffect, useCallback, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import CustomDatePicker from "../../StyledComponents/DatePicker/CustomDatePicker";
import Error from "../../../Modules/StyledComponents/Toastify/Error";
import calendar_icon_custom from "../../../Assets/images/calendar_icon.png";
import CustomDropdown from "./Dropdown";
import { DropDown as Dropdownstyle } from "../../HealthProfile/styles";
import arrowIcon from "../../../Assets/images/arrowIcon.png"; // Import your arrow icon
import {
  GetPatientDetailUpdate,
  GetPatientProfileUpdate,
  GetPatientProfileRemove,
  GetEmailExist,
  GetPhoneExist,
  Getprofileupdatestatus,
  SetEmailExist,
  SetPhoneExist,
  GetClinicalInfoSignedForm,
} from "../../../StateManagement/Reducers/SettingState";
import { ProviderListApi } from "../../../MiddleWare/Apis/MessengerApi";
import { Decrypt_Value } from "../../../MiddleWare/EncryptDecrypt";

import {
  Text,
  Div,
  NormalImage,
  Button,
  Form,
  Modal,
  ModalContainer,
  ModalHeader,
  ModalBody,
  FormGroup,
  FormLabel,
  ModalFooter,
  ModalTitle,
  Image,
} from "../../StyledComponents";

import {
  Display,
  Displayerror,
  DisplayerrorText,
  Inputbox,
  CurveImg,
  ModalDialog,
  Hrline,
  DragDrop,
  FileInput,
  SelectInput,
  DropdownImage,
  DropDownDiv,
  DropdownOptions,
  TooltipText,
  Tooltip,
  TooltipComponent,
  Dropdown1,
  DropdownItem1,
  AutoCompleteWrapper,
} from "./styles";
import { AiOutlinePlus, AiOutlineDelete } from "react-icons/ai";
import BlueCurve from "../../../Assets/images/Ellipse_2.png";
import ReactCrop from "react-image-crop";
import "react-image-crop/dist/ReactCrop.css";
import { BsXLg } from "react-icons/bs";
import UploadFile1 from "../../../Assets/images/uploadDoc.png";
import { debounce } from "../../HomeWork";
import { Imagecalendar } from "../../StyledComponents/DatePicker/styles";
import { GetUserDetails } from "../../../StateManagement/Reducers/TopNavbarState";
import { ErrorMessage } from "./styles";
import { PhoneNumberUtil, PhoneNumberFormat } from "google-libphonenumber";

import axios from "axios";
import { AutoComplete, Select, Switch } from "antd";
import CustomSuffixIcon from "../Insurance/CustomSuffixIcon";

const { Option } = Select;

const phoneUtil = PhoneNumberUtil.getInstance();

const isoToFlag = (iso) =>
  iso
    .toUpperCase()
    .replace(/./g, (char) => String.fromCodePoint(127397 + char.charCodeAt())) +
  "\uFE0F";

const regionNames = new Intl.DisplayNames(["en"], { type: "region" });

const regions = phoneUtil.getSupportedRegions();

const countries = Array.from(regions)
  .map((iso) => {
    const code = phoneUtil.getCountryCodeForRegion(iso);
    // console.log(iso, code);
    if (!code) return null;

    return {
      iso,
      name: regionNames.of(iso) || iso,
      dialCode: `+${code}`,
      flag: isoToFlag(iso),
      flagSvg: `https://cdnjs.cloudflare.com/ajax/libs/twemoji/14.0.2/svg/${iso
        .toUpperCase()
        .split("")
        .map((c) => (c.charCodeAt(0) - 65 + 0x1f1e6).toString(16))
        .join("-")}.svg`,
    };
  })
  .filter(Boolean)
  .sort((a, b) => a.name.localeCompare(b.name));

const getMainRegionForCode = (codeStr) => {
  if (!codeStr) return null;
  try {
    const numericCode = parseInt(codeStr.replace(/\D/g, ""), 10);
    return phoneUtil.getRegionCodeForCountryCode(numericCode);
  } catch (e) {
    return null;
  }
};

const PhoneInput = ({ value = {}, onChange, className = "", disabled = false }) => {
  const { country, number = "" } = value;

  const currentCountry = country || countries[0];

  if (!currentCountry) return null;

  const triggerChange = (changed) => {
    onChange?.({
      country: currentCountry,
      number,
      ...changed,
    });
  };

  const isError = className.includes("error-border");

  return (
    <div style={{ display: "flex", width: "100%", alignItems: "center", gap: "12px" }}>
      <Select
        showSearch
        status={isError ? "error" : undefined}
        style={{
          minWidth: "100px",
          maxWidth: "110px",
          height: "36px",
          display: "flex",
          alignItems: "center",
          borderRadius: "0.25rem",
        }}
        value={currentCountry.iso}
        disabled={disabled}
        optionLabelProp="label"
        onChange={(iso) =>
          triggerChange({
            country: countries.find((c) => c.iso === iso),
          })
        }
        filterOption={(input, option) => {
          const searchStr = input.toLowerCase().replace(/\+/g, "");
          return (
            (option.name && option.name.toLowerCase().includes(searchStr)) ||
            (option.dialcode && option.dialcode.replace(/\+/g, "").includes(searchStr)) ||
            (option.value && option.value.toLowerCase().includes(searchStr))
          );
        }}
      >
        {countries.map((c) => (
          <Option
            key={c.iso}
            value={c.iso}
            name={c.name}
            dialcode={c.dialCode}
            label={
              <div style={{ display: "flex", alignItems: "center" }}>
                <img
                  src={c.flagSvg}
                  width={18}
                  style={{ marginRight: 8 }}
                  alt={c.iso}
                />
                ({c.dialCode})
              </div>
            }
          >
            <div style={{ display: "flex", alignItems: "center" }}>
              <img
                src={c.flagSvg}
                width={18}
                style={{ marginRight: 8 }}
                alt={c.iso}
              />
              {c.name} ({c.dialCode})
            </div>
          </Option>
        ))}
      </Select>

      <input
        style={{
          borderRadius: "0.25rem",
          height: "36px",
          zIndex: 1,
          flex: 1,
          border: isError ? "1px solid #dc3545" : "1px solid #d9d9d9",
          padding: "4px 11px",
          outline: "none",
        }}
        value={number}
        placeholder="Phone number"
        disabled={disabled}
        onChange={(e) =>
          triggerChange({
            number: e.target.value.replace(/\D/g, ""),
          })
        }
      />
    </div>
  );
};
const EditProfile = () => {
  const dispatch = useDispatch();
  // const Navigate = useNavigate();
  const [selectedCode, setSelectedCode] = useState([]);
  const [revertReason, setRevertReason] = useState("");
  const [defaltPhoneType, setDefaltPhoneType] = useState("");
  const [defaltEmailType, setDefaltEmailType] = useState("");
  const [previewimg, setpreviewimg] = useState("");
  const [select, setSelect] = useState(false);
  const [upload, setUpload] = useState(true);
  const [showpop1, Setshowpop1] = useState(false);
  const [fname, setfname] = useState("");
  const [mname, setmname] = useState([]);
  const [lname, setlname] = useState([]);
  const [patimg, setpatimg] = useState([]);
  const [suffix, setsuffix] = useState("");
  const [ss, setss] = useState([]);
  const [street, setstreet] = useState([]);
  const [city, setcity] = useState([]);
  const [state, setstate] = useState("");
  const [status1, setstatus1] = useState("");
  const [status, setstatus] = useState("");
  const [providerID, setproviderID] = useState("");
  const [ethnicity1, setethnicity1] = useState("");
  const [ethnicity2, setethnicity2] = useState("");
  const [language1, setlanguage1] = useState("");
  const [country_code, setcountry_code] = useState([]);
  const [sex1, setsex1] = useState("");
  const [pronoun, setPronoun] = useState("");
  const [sexualOrientation, setSexualOrientation] = useState("");
  const [age, setAge] = useState("");
  const [genderIdentity, setGenderIdentity] = useState("");
  const [religiousAffiliation, setReligiousAffiliation] = useState("");
  const [interpreterRequired, setInterpreterRequired] = useState(false);
  const [annualFamilyIncome, setAnnualFamilyIncome] = useState("");
  const [ssvalue, setssvalue] = useState("");
  const [streetErr, setStreetErr] = useState(false);
  const [cityErr, setCityErr] = useState(false);
  const [zipErr, setZipErr] = useState(false);
  const [raceErr, setraceErr] = useState(false);
  const [statusErr, setstatusErr] = useState(false);
  const [dobErr, setdobErr] = useState(false);
  const [genderErr, setgenderErr] = useState(false);
  const [ethniErr, setethniErr] = useState(false);

  const [preferredName, setPreferredName] = useState("");
  const [title, setTitle] = useState("");
  const [pcp, setPcp] = useState("");
  const [providersList, setProvidersList] = useState([]);
  const [faxNumber, setFaxNumber] = useState("");
  const [addressLine2, setAddressLine2] = useState("");
  const [county, setCounty] = useState("");
  const [dateFirstSeen, setDateFirstSeen] = useState("");
  const [pcpRelease, setPcpRelease] = useState("");
  const [hippaSigned, setHippaSigned] = useState(false);
  const [roiSigned, setRoiSigned] = useState(false);

  const clinicalInfoSignedForm = useSelector((state) => state.Setting.ClinicalInfoSignedForm);

  useEffect(() => {
    const pid = localStorage.getItem("PID") && Decrypt_Value(localStorage.getItem("PID"), "vozoportal");
    if (pid) {
      dispatch(GetClinicalInfoSignedForm(pid));
    }
  }, [dispatch]);

  useEffect(() => {
    if (clinicalInfoSignedForm) {
      let parsedForm = clinicalInfoSignedForm;
      if (typeof clinicalInfoSignedForm === "string") {
        try {
          parsedForm = JSON.parse(clinicalInfoSignedForm);
        } catch (e) {
          console.error("Failed to parse clinicalInfoSignedForm", e);
        }
      }
      if (
        parsedForm?.Notice_of_Privacy_Practices === true
      ) {
        setRoiSigned(true);
      } else {
        setRoiSigned(false);
      }
      if (
        parsedForm?.Release_of_Information_HIPAA_AUTHORIZATION_FOR_USE_OR_DISCLOSURE_OF_HEALTH_INFORMATION === true
      ) {
        setHippaSigned(true);
      } else {
        setHippaSigned(false);
      }
    }
  }, [clinicalInfoSignedForm]);

  const [callEffect, setcallEffect] = useState(false);
  const [samePhoneErr, setSamePhoneErr] = useState([]);
  const [forPhoneNumberEmpty, setforPhoneNumberEmpty] = useState(true);
  const phoneUtil = PhoneNumberUtil.getInstance();
  const phoneRef = useRef();
  const lastKeyPressed = useRef(null);
  const [originalPhoneList, setOriginalPhoneList] = useState([]);
  const [inputList, setInputList] = useState([
    { phone: "", type: "Mobile", codeText: "", code: "" },
  ]);
  const [inputList2, setInputList2] = useState([{ email: "", type: "Work" }]);
  const [validation, setValidation] = useState([
    { emailErr: false, typeErr: false, msg: "", typemsg: "" },
  ]);
  const [phoneValidation, setPhoneValidation] = useState([
    { numberErr: false, typeErr: false, msg: "", typemsg: "" },
  ]);
  const [workMailErr, setWorkMailErr] = useState(false);
  const [active, setActive] = useState("");
  const [imgfile, setimgfile] = useState("");
  const [err, seterr] = useState(false);
  const [err1, seterr1] = useState(false);
  const [suffixerr, setSufixErr] = useState(false);

  const [rowId, setRowId] = useState(0);
  const [phoneRowId, setPhoneRowId] = useState(0);
  const [mailcheck, setMailcheck] = useState("");

  const [ssnErr, setSSNErr] = useState(false);

  useEffect(() => {
    const fetchProviders = async () => {
      try {
        const res = await ProviderListApi();
        if (res.status === 200 && res.data !== "no provider") {
          let data = Decrypt_Value(res.data, "vozoportal");
          setProvidersList(data);
        }
      } catch (err) {
        console.error(err);
      }
    };
    fetchProviders();
  }, []);

  const [showsave, setshowsave] = useState(true);
  const [UpdateStatus, setupdateprofilestatus] = useState(0);

  const [labeltext, setlabeltext] = useState("add file");

  const [crop, SetCrop] = useState({
    unit: "px",
    x: 25,
    y: 25,
    width: 150,
    height: 150,
  });
  const [croppedImageUrl, setcroppedImageUrl] = useState("");
  const [normalImg, setNormalImg] = useState(false);
  const [jpegFile, setjpegFile] = useState("");
  const [imageRef, setImageRef] = useState();
  const [show, setShow] = useState(false);
  const [ModalAnimat] = useState(true);
  const [uploadbtndisabled, setuploadbtndisabled] = useState(false);
  const [savepicbtndisabled, setsavepicbtndisabled] = useState(false);
  const [fromdate, setFromDate] = useState("");

  useEffect(() => {
    if (fromdate) {
      const calculatedAge = moment().diff(moment(fromdate, "YYYY-MM-DD"), "years");
      setAge(calculatedAge.toString());
    } else {
      setAge("");
    }
  }, [fromdate]);
  const [validDate, setValidDate] = useState("");
  const [showpicker, setShowPicker] = useState(false);
  const [validDateFirstSeen, setValidDateFirstSeen] = useState("");
  const [showPickerFirstSeen, setShowPickerFirstSeen] = useState(false);
  const [dropDown, setDropDown] = useState(false);
  const [dropDown1, setDropDown1] = useState(false);
  const [dropDown2, setDropDown2] = useState(false);
  const [dropDown3, setDropDown3] = useState(false);
  const [dropDown4, setDropDown4] = useState(false);
  const [dropDown5, setDropDown5] = useState(false);
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [selectedOptions2, setSelectedOptions2] = useState([]);
  const [tooltipVisible, setTooltipVisible] = useState(false);
  const [countryCodes, setCountryCodes] = useState([]);
  const [showOptions, setShowOptions] = useState(false);
  const [countryCodeErr, setCountryCodeErr] = useState(false);
  const [stateErr, setstateErr] = useState(false);

  const mobileRef = useRef();
  const fileInputRef = useRef(null);

  const inputNotRef = useRef(null);
  const maritalNotRef = useRef(null);
  const languageNotRef = useRef(null);
  const raceNotRef = useRef(null);
  const ethinicity2NotRef = useRef(null);
  const stateNotRef = useRef(null);
  const { Option } = Select;

  const [searchText, setSearchText] = useState([""]);

  const [filteredOptions, setFilteredOptions] = useState([[]]);

  let backurl = "";
  let firstDot = window.location.hostname.split(".");
  let DBhost;
  if (firstDot[0] !== "localhost") {
    backurl = process.env.REACT_APP_BACKEND_FILE_ACCESS.replace(
      "oemr",
      firstDot[0],
    );
  } else {
    backurl = process.env.REACT_APP_BACKEND_FILE_ACCESS;
  }
  if (
    firstDot[0] === "localhost" ||
    firstDot[0] === "test" ||
    firstDot[0] === "mumbai" ||
    firstDot[0] === "production" ||
    firstDot[0] === "ehr" ||
    firstDot[0] === "ehr1" ||
    firstDot[0] === "dev"
  ) {
    DBhost = "default";
  } else {
    DBhost = firstDot[0];
  }
  const File_URL = backurl + "/sites/" + DBhost + "/documentimg/";

  const handleKeyDown = (e) => {
    if (e.key === " ") {
      e.preventDefault();
    }
    lastKeyPressed.current = e.key;
  };

  const handleSearchChange = (data, ind) => {
    const list = [...inputList];
    list[ind]["code"] = data;
    list[ind]["codeText"] = data;
    list[ind]["phone"] = "";
    setInputList(list);
    const phoneErrs = JSON.parse(JSON.stringify(phoneValidation));
    phoneErrs[ind]["msg"] = "";
    phoneErrs[ind]["codeErr"] = false;
    phoneErrs[ind]["codeMsg"] = "";
    phoneErrs[ind]["numberErr"] = false;
    phoneErrs[ind]["msg"] = "";
    setPhoneValidation(phoneErrs);
  };
  const handleInputChangeP = (e, index) => {
    setcallEffect(!callEffect);
    samePhoneErr[index] = "false";

    if (typeof e === "string") {
      const phoneErrs = JSON.parse(JSON.stringify(phoneValidation));
      const list = [...inputList];
      let values = e.split("-");

      list[index]["code"] = values[1].startsWith("+") ? values[1] : "+" + values[1];
      list[index]["codeText"] = values[2]; // country code like 'IN'
      phoneErrs[index]["msg"] = "";
      list[index]["phone"] = "";
      phoneErrs[index]["codeErr"] = false;
      phoneErrs[index]["codeMsg"] = "";
      phoneErrs[index]["numberErr"] = false;
      phoneErrs[index]["msg"] = "";
      setPhoneValidation(phoneErrs);
      setInputList(list);
      setforPhoneNumberEmpty(false);
    } else {
      const { name, value } = e.target;

      if (name !== "code") {
        const list = [...inputList];
        const input = value;
        const codeType = list[index]["codeText"]; // Should be a valid country code like 'US'

        const phoneErrs = JSON.parse(JSON.stringify(phoneValidation));

        if (input === "") {
          list[index][name] = input;
          phoneErrs[index]["numberErr"] = false;
          phoneErrs[index]["msg"] = "";
          setInputList(list);
          setPhoneValidation(phoneErrs);
          setforPhoneNumberEmpty(index === 0);
          return;
        }

        let isDuplicate = false;
        if (
          list.filter(
            (f, i) =>
              i !== index &&
              f.phone.replace(/\s+/g, "") === input.replace(/\s+/g, "") &&
              f.code === list[index]["code"],
          ).length > 0
        ) {
          isDuplicate = true;
          list[index][name] = input; // <--- ADDED THIS LINE TO PREVENT CLEARING THE INPUT
          phoneErrs[index]["numberErr"] = true;
          phoneErrs[index]["msg"] = "You are Entering a Duplicate Number";
          setPhoneValidation(phoneErrs);
        } else {
          list.forEach((x, i) => {
            phoneErrs[i]["numberErr"] = false;
            phoneErrs[i]["msg"] = "";
          });
        }

        if (!isDuplicate) {
          try {
            const phoneNumber = phoneUtil.parseAndKeepRawInput(input, codeType);

            const isValid = phoneUtil.isValidNumber(phoneNumber);
            const isPossible = phoneUtil.isPossibleNumber(phoneNumber);

            if (isPossible && isValid) {
              const formattedNumber = phoneUtil.format(
                phoneNumber,
                PhoneNumberFormat.INTERNATIONAL,
              );
              const [, ...restOfNumber] = formattedNumber.split(" ");
              const localNumber = restOfNumber.join("");

              list[index][name] = localNumber;
              phoneErrs[index]["numberErr"] = false;
              phoneErrs[index]["msg"] = "";
              setforPhoneNumberEmpty(false);
              setPhoneValidation(phoneErrs);
              setPhoneRowId(index);
              optimizedPhoneFn({
                phone: localNumber,
                code: list[index]["code"],
                codeText: list[index]["codeText"]
              });
            } else {
              list[index][name] = input;
              phoneErrs[index]["numberErr"] = true;
              phoneErrs[index]["msg"] = "Enter a Valid Number";
              setPhoneValidation(phoneErrs);
              setforPhoneNumberEmpty(false);
            }
          } catch (error) {
            // Parsing failed (incomplete or invalid number)
            list[index][name] = input;
            phoneErrs[index]["numberErr"] = true;
            phoneErrs[index]["msg"] = "Enter a Valid Number";
            setPhoneValidation(phoneErrs);
            setforPhoneNumberEmpty(false);
          }
        }
      } else {
        const list = [...inputList];
        let values = e.split("-");
        list[index]["code"] = values[1].startsWith("+") ? values[1] : "+" + values[1];
        setInputList(list);
        setforPhoneNumberEmpty(false);
      }

      if (e.target.value === "" && index === 0) {
        setforPhoneNumberEmpty(true);
      }
    }
  };

  const closePicker = () => {
    setShowPicker(false);
  };
  const handlepicker = (e) => {
    e.preventDefault();
    setShowPicker(true);
  };

  const dateSelect = (value) => {
    if (Object.prototype.toString.call(value) === "[object Date]") {
      setFromDate(moment(value).format("YYYY-MM-DD"));
      setValidDate(new Date(value));
    } else {
      setFromDate("");
      setValidDate("");
    }
    closePicker();
  };

  const keyDownExpiry = (event) => {
    const inp = document.querySelector("#date");

    const key = event.keyCode || event.charCode;

    if (key !== 8 && key !== 46) {
      if (inp.value.length === 4) {
        inp.value = inp.value + "-";
      }
    }
    if (key !== 8 && key !== 46) {
      if (inp.value.length === 7) {
        inp.value = inp.value + "-";
      }
    }
    if ((key === 8 || key === 46) && inp.value.length > 7) {
      inp.value = inp.value.replace(/\/$/, "");
    }
  };

  const closepopup = () => {
    setShow(!show);
    setSelect(false);
    setUpload(true);
    setpreviewimg("");
    setcroppedImageUrl(null);
    setImageRef();
    setimgfile("");
  };

  const GenderDetails = useSelector((state) => state.Setting.PatGenderDetails);
  const MaritalStatus = useSelector((state) => state.Setting.PatMariDetails);
  const LanguageLists = useSelector((state) => state.Setting.PatLangDetails);
  const RaceDetails = useSelector((state) => state.Setting.PatRaceDetails);
  const PatDetails = useSelector((state) => state.TopNavbar.userDetails);
  const mailChecking = useSelector((state) => state.Setting.MailCheck);
  const phoneChecking = useSelector((state) => state.Setting.PhoneCheck);
  const Refresh = useSelector((state) => state.Setting.Refresh);
  const constate = useSelector((state) => state.Setting.PatientState);
  const [holdSave, setHoldSave] = useState(false);
  const dataURLtoFile = (dataurl, filename) => {
    var arr = dataurl.split(","),
      mime = arr[0].match(/:(.*?);/)[1],
      bstr = atob(arr[1]),
      n = bstr.length,
      u8arr = new Uint8Array(n);

    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }

    return new File([u8arr], filename, { type: mime });
  };

  const FileHandleChange = (e) => {
    setpreviewimg("");

    let iSize = e.target.files[0].size / 1024;
    iSize = Math.round(iSize * 100) / 100;

    if (iSize > 2048) {
      toast(<Error msg="Please select a file less than 2mb" />, {
        containerId: "B",
        className: "error_badge",
      });

      e.target.value = "";
      return false;
    }

    const fileName = e.target.value.split("\\").pop();
    const extension = fileName.split(".").pop();
    const allowedExtensions = ["jpg", "jpeg", "png"];
    if (!allowedExtensions.includes(extension?.toLowerCase())) {
      toast(<Error msg="Please select a valid file" />, {
        containerId: "B",
        className: "error_badge",
      });
      return false;
    }
    setimgfile((prev) => {
      return (prev = e.target.files[0]);
    });
    if (fileName) {
      if (e.target.files && e.target.files.length > 40) {
        e.preventDefault();
        e.stopPropagation();
        setlabeltext(fileName.slice(0, 4) + "..." + extension);
      } else {
        setlabeltext(fileName);
      }
    } else {
      setlabeltext("add file");
    }
    const reader = new FileReader();
    reader.addEventListener("load", () => setpreviewimg(reader.result));
    reader.readAsDataURL(e.target.files[0]);
  };

  const UploadFile = () => {
    setuploadbtndisabled(true);
    setTimeout(() => {
      setuploadbtndisabled(false);
    }, 1000);
    setSelect(true);
    setUpload(false);
    setlabeltext("add file");
    setpreviewimg("");
    setShow(true);
  };

  const CloseFile = () => {
    setSelect(false);
    setUpload(true);
    setpreviewimg("");
    setcroppedImageUrl(null);
    setImageRef();
    setimgfile("");
  };

  const openFilePicker = () => {
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
      fileInputRef.current.click();
    }
  };

  const UploadProfilePicture = () => {
    setsavepicbtndisabled(true);
    setTimeout(() => {
      setsavepicbtndisabled(false);
    }, 1500);

    if (imgfile === "" || imgfile === null) {
      toast(<Error msg="Please Select the File!." />, {
        containerId: "B",
        className: "error_badge",
      });

      return false;
    }

    setSelect(false);
    setUpload(true);

    const dataArray = new FormData();
    const file11 = dataURLtoFile(jpegFile, labeltext);
    dataArray.append("imgfile", file11);

    dispatch(GetPatientProfileUpdate(dataArray));
  };

  const RemoveProfilePicture = () => {
    dispatch(GetPatientProfileRemove());
    Setshowpop1(false);
    setpatimg(null);
    setimgfile(null);
  };

  const CancelPage = () => {
    // Navigate("/");
  };

  const getcropimage = (e) => {
    if (!imgfile || imgfile === "") {
      toast(<Error msg="Please Select the File!" />, {
        containerId: "B",
        className: "error_badge",
      });
      return false;
    } else {
      setShow(!show);
      makeClientCrop(crop);
      if (normalImg === false) {
        setNormalImg(true);
        makeClientCrop(crop);
        setpreviewimg("");
      }
    }
  };

  const popclsbtn = () => {
    setlabeltext("add file");
    setpreviewimg("");
    setcroppedImageUrl(null);

    closepopup();
  };

  function getFormChanges(currentState, originalState) {
    const changes = {};

    // Compare simple fields (unchanged)
    const simpleFields = [
      "fname",
      "mname",
      "lname",
      "title",
      "suffix",
      "active",
      "pronoun",
      "sexualOrientation",
      "genderIdentity",
      "religiousAffiliation",
      "interpreter",
      "annualFamilyIncome",
      "pname",
      "date_first_seen",
      "pcp_release",
      "faxNumber",
      "ss",
      "street",
      "city",
      "postal_code",
      "sex",
      "race",
      "ethnicity",
      "language",
      "providerID",
      "status",
      "dob",
      "defaultEmailType",
      "address_line_2",
      "county",
    ];

    const findMatchingState = (stateValue) => {
      return constate.find(
        (state) => state.title === stateValue || state.option_id === stateValue,
      );
    };

    const originalStateObj = findMatchingState(originalState.state);
    const currentStateObj = findMatchingState(currentState.state);

    if (
      originalStateObj?.title !== currentStateObj?.title ||
      originalStateObj?.option_id !== currentStateObj?.option_id
    ) {
      changes.state = {
        oldValue: originalStateObj
          ? originalStateObj.title || originalStateObj.option_id
          : originalState.state,
        newValue: currentStateObj
          ? currentStateObj.title || currentStateObj.option_id
          : currentState.state,
      };
    }
    simpleFields.forEach((field) => {
      // Treat null, undefined, and empty string as equivalent for comparison
      const origVal = (originalState[field] === null || originalState[field] === undefined) ? "" : originalState[field];
      const currVal = (currentState[field] === null || currentState[field] === undefined) ? "" : currentState[field];

      if (currVal !== origVal) {
        changes[field] = {
          oldValue: originalState[field] === undefined ? null : originalState[field],
          newValue: currVal === "" ? null : currentState[field],
        };
      }
    });

    // Compare defaltPhoneType separately with normalization (case-insensitive)
    const normalizePhoneType = (type) => (type || "").toLowerCase();
    if (
      normalizePhoneType(currentState.defaltPhoneType) !==
      normalizePhoneType(originalState.defaultPhoneType)
    ) {
      changes.defaltPhoneType = {
        oldValue: originalState.defaultPhoneType,
        newValue: currentState.defaltPhoneType,
      };
    }



    // Compare emails (case insensitive)
    const normalizedOriginalEmails = originalState.email.map((email) => ({
      ...email,
      email: email.email.toLowerCase(),
    }));

    const normalizedCurrentEmails = currentState.email.map((email) => ({
      ...email,
      email: email.email.toLowerCase(),
    }));

    const emailChanges = compareEmailLists(
      currentState.email,
      originalState.email,
    );
    if (emailChanges.length > 0) {
      changes.email = emailChanges;
    }

    return changes;
  }

  function normalizePhone(phone, code) {
    if (!phone) return "";

    // Remove all non-digit characters
    const digits = phone.replace(/\D/g, "");

    // If code is provided separately, combine it with the phone
    if (code) {
      const cleanCode = code.replace(/\D/g, "");
      return cleanCode + digits;
    }

    // If code is embedded in phone (like "+1 8888888888"), extract it
    if (phone.startsWith("+")) {
      return digits;
    }

    return digits;
  }



  function compareEmailLists(currentEmails, originalEmails) {
    const changes = [];

    // Convert both lists to lowercase for comparison
    const currentNormalized = currentEmails
      .map((e) => ({
        ...e,
        email: e.email?.toLowerCase(),
      }))
      .filter((e) => e.email);

    const originalNormalized = originalEmails
      .map((e) => ({
        ...e,
        email: e.email?.toLowerCase(),
      }))
      .filter((e) => e.email);

    // Check for added or modified emails
    currentNormalized.forEach((current) => {
      const matchedOriginal = originalNormalized.find(
        (orig) => orig.email === current.email,
      );

      if (!matchedOriginal) {
        // New email added
        changes.push({
          type: current.type,
          action: "added",
          value: current.email,
        });
      } else if (matchedOriginal.type !== current.type) {
        // Email type changed
        changes.push({
          action: "modified",
          value: current.email,
          oldType: matchedOriginal.type,
          newType: current.type,
        });
      }
    });

    // Check for removed emails
    originalNormalized.forEach((original) => {
      const stillExists = currentNormalized.some(
        (curr) => curr.email === original.email,
      );

      if (!stillExists) {
        changes.push({
          type: original.type,
          action: "removed",
          value: original.email,
        });
      }
    });

    return changes;
  }

  // KEEP THIS ONE (the correct version):
  function comparePhoneLists(currentList, originalList) {
    const changes = [];

    const normalizePhone = (phone, code) => {
      if (!phone) return "";
      const digits = phone.replace(/\D/g, "");
      if (code) {
        const cleanCode = code.replace(/\D/g, "");
        return cleanCode + digits;
      }
      return digits;
    };

    // Create unique signature for each phone: "type|||normalizedNumber|||codeText"
    const createPhoneSignature = (item) => {
      const normalized = normalizePhone(item.phone, item.code);
      return `${item.type}|||${normalized}|||${item.codeText || ""}`;
    };

    // Filter out empty phones and create signature sets
    const originalSignatures = new Set(
      originalList
        .filter((item) => item.phone && item.phone.trim())
        .map(createPhoneSignature),
    );

    const currentSignatures = new Set(
      currentList
        .filter((item) => item.phone && item.phone.trim())
        .map(createPhoneSignature),
    );

    // Find added phones
    currentList.forEach((item) => {
      if (!item.phone || !item.phone.trim()) return;

      const signature = createPhoneSignature(item);
      if (!originalSignatures.has(signature)) {
        changes.push({
          type: item.type,
          action: "added",
          value: item.phone,
          code: item.code,
          codeText: item.codeText || "",
        });
      }
    });

    // Find removed phones
    originalList.forEach((item) => {
      if (!item.phone || !item.phone.trim()) return;

      const signature = createPhoneSignature(item);
      if (!currentSignatures.has(signature)) {
        changes.push({
          type: item.type,
          action: "removed",
          value: item.phone,
          code: item.code,
          codeText: item.codeText || "",
        });
      }
    });

    return changes;
  }

  const OnSubmit = (e) => {
    e.preventDefault();
    let err = 0;

    if (!forPhoneNumberEmpty) {
      const PhoneErrs = JSON.parse(JSON.stringify(phoneValidation));
      for (let i = 0; i < inputList.length; i++) {
        if (
          phoneValidation[i].msg === "You are Entering a Duplicate Number" ||
          phoneValidation[i].msg === "Phone Number already Existed"
        ) {
          err = 4;
          phoneRef.current?.scrollIntoView({
            behavior: "smooth",
            block: "center",
          });
          continue;
        }
        try {
          if (inputList[i].phone === "" && inputList[i].code === "") {
            PhoneErrs[i].numberErr = false;
            PhoneErrs[i].codeErr = false;
            PhoneErrs[i].msg = "";
            continue;
          }

          const phoneNumber = phoneUtil.parseAndKeepRawInput(
            `${inputList[i].code} ${inputList[i].phone}`,
            inputList[i].codeText,
          );

          const isValid = phoneUtil.isValidNumber(phoneNumber);
          const isPossible = phoneUtil.isPossibleNumber(phoneNumber);

          if (!isValid || !isPossible) {
            PhoneErrs[i].numberErr = true;
            PhoneErrs[i].msg = "Enter a valid Phone Number";
            PhoneErrs[i].codeErr = false;
            err = 2;
            phoneRef.current?.scrollIntoView({
              behavior: "smooth",
              block: "center",
            });
            setPhoneValidation(PhoneErrs);
            return;
          } else {
            PhoneErrs[i].numberErr = false;
            PhoneErrs[i].codeErr = false;
            PhoneErrs[i].msg = "";
          }
        } catch (e) {
          // parsing failed → treat as invalid
          PhoneErrs[i].numberErr = true;
          PhoneErrs[i].msg = "Enter a valid Phone Number";
          PhoneErrs[i].codeErr = false;
          err = 2;
          setPhoneValidation(PhoneErrs);

          phoneRef.current?.scrollIntoView({
            behavior: "smooth",
            block: "center",
          });
          return;
        }

        if (inputList[i].phone === "" && inputList[i].code !== "") {
          PhoneErrs[i]["numberErr"] = true;
          PhoneErrs[i]["msg"] = "Enter the Phone Number";
          setPhoneValidation(PhoneErrs);
          err = 2;
        } else if (inputList[i].phone !== "" && inputList[i].code === "") {
          PhoneErrs[i]["codeErr"] = true;
          PhoneErrs[i]["numberErr"] = true;
          PhoneErrs[i]["msg"] = "Select Country Code & Number";
          setPhoneValidation(PhoneErrs);
          err = 2;
        } else {
          PhoneErrs[i]["numberErr"] = false;
          PhoneErrs[i]["codeErr"] = false;
          PhoneErrs[i]["msg"] = "";
          setPhoneValidation(PhoneErrs);
        }
      }
      const PhoneErrs1 = JSON.parse(JSON.stringify(PhoneErrs));

      for (let i = 0; i < inputList.length; i++) {
        if (inputList[i].type === "") {
          PhoneErrs1[i]["typeErr"] = true;
          PhoneErrs1[i]["typemsg"] = "Select the Phone Type";
          setPhoneValidation(PhoneErrs1);
          err = 2;
        }
      }

      const allPhoneErrorsFalse = phoneValidation.every(
        (obj) => obj.numberErr === false && obj.typeErr === false,
      );

      if (!allPhoneErrorsFalse) {
        err = 2;
        phoneRef.current?.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
      }
    } else {
      const PhoneErrs = phoneValidation
        ? JSON.parse(JSON.stringify(phoneValidation))
        : [
          {
            numberErr: false,
            typeErr: false,
            msg: "",
            codeMsg: "",
            typemsg: "",
            codeErr: false,
          },
        ];

      if (inputList[0].phone === "" && inputList[0].code === "") {
        PhoneErrs[0]["numberErr"] = false;
        PhoneErrs[0]["codeErr"] = false;
        PhoneErrs[0]["msg"] = "";
        setPhoneValidation(PhoneErrs);
        err = 0;
      } else if (inputList[0].phone === "" && inputList[0].code !== "") {
        PhoneErrs[0]["numberErr"] = true;
        PhoneErrs[0]["msg"] = "Enter the Phone Number";
        PhoneErrs[0]["codeErr"] = false;
        setPhoneValidation(PhoneErrs);
        err = 2;
      } else if (inputList[0].code === "" && inputList[0].phone !== "") {
        PhoneErrs[0]["numberErr"] = false;
        PhoneErrs[0]["codeErr"] = true;
        PhoneErrs[0]["msg"] = "Enter the Country code";
        setPhoneValidation(PhoneErrs);
        err = 2;
      } else {
        PhoneErrs[0]["codeErr"] = false;
        PhoneErrs[0]["numberErr"] = false;
        PhoneErrs[0]["msg"] = "";
        setPhoneValidation(PhoneErrs);
      }
      const allPhoneErrorsFalse = phoneValidation.every(
        (obj) => obj.numberErr === false && obj.typeErr === false,
      );

      if (!allPhoneErrorsFalse) {
        err = 2;
        phoneRef.current?.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
      }
    }
    if (err > 0) return;
    const handlePhoneType = () => {
      if (!Array.isArray(inputList) || inputList.length === 0)
        return defaltPhoneType ?? "";

      // Loop through the inputList to find a match
      for (let i = 0; i < inputList.length; i++) {
        if (
          defaltPhoneType?.toLowerCase() === inputList[i]?.type?.toLowerCase() &&
          inputList[i]?.code === ""
        ) {
          return inputList[0]?.type ?? "";
        }
      }

      // Default fallback
      return defaltPhoneType ?? inputList[0]?.type ?? "";
    };
    // Create an object representing the current form state
    const currentFormState = {
      fname,
      mname,
      lname,
      title: title,
      suffix: suffix,
      pronoun: pronoun,
      sexualOrientation: sexualOrientation,
      genderIdentity: genderIdentity,
      religiousAffiliation: religiousAffiliation,
      interpreter: interpreterRequired ? 1 : 0,
      annualFamilyIncome: annualFamilyIncome,
      pname: preferredName,
      date_first_seen: dateFirstSeen,
      pcp_release: pcpRelease,
      faxNumber: faxNumber,
      active,
      ss,
      street,
      address_line_2: addressLine2,
      city,
      state,
      county,
      postal_code: country_code,
      sex: sex1,
      race: ethnicity1,
      ethnicity: ethnicity2,
      language: language1,
      providerID,
      status,
      dob: fromdate,
      defaultEmailType: defaltEmailType,
      // defaltPhoneType: defaltPhoneType,
      defaltPhoneType: handlePhoneType() ? handlePhoneType().toLowerCase() : "",

      // Handle emails
      email: inputList2.map((item) => ({
        email: item.email,
        type: item.type,
      })),
      // Add phone data (assuming you have a phone input list similar to email)
      phone: inputList.map((item) => ({
        phone: item.phone,
        type: item.type,
        code: item.code,
        codeText: item.codeText || "",
      })),
    };
    // Create an object representing the original state from PatDetails
    const originalState = {
      fname: PatDetails.fname,
      mname: PatDetails.mname,
      lname: PatDetails.lname,
      title: PatDetails.title,
      suffix: PatDetails.suffix,
      pronoun: PatDetails.pronoun,
      sexualOrientation: PatDetails.sexual_orientation,
      genderIdentity: PatDetails.gender_identity,
      religiousAffiliation: PatDetails.religious_affiliation,
      interpreter: PatDetails.interpreter == 1 ? 1 : 0,
      annualFamilyIncome: PatDetails.annual_family_income,
      pname: PatDetails.pname,
      date_first_seen: PatDetails.date_first_seen || PatDetails.dateFirstSeen,
      pcp_release: PatDetails.pcp_release || PatDetails.pcpRelease,
      faxNumber: PatDetails.faxId || "",
      active: PatDetails.active,
      ss: PatDetails.ss,
      street: PatDetails.street,
      address_line_2: PatDetails.address_line_2,
      city: PatDetails.city,
      state: PatDetails.state,
      county: PatDetails.county,
      postal_code: PatDetails.postal_code,
      sex: PatDetails.sex,
      race: PatDetails.race,
      ethnicity: PatDetails.ethnicity,
      language: PatDetails.language,
      providerID: PatDetails.providerID,
      status: PatDetails.status,
      dob: PatDetails.DOB,
      defaultPhoneType: PatDetails.phone_default,
      defaultEmailType: PatDetails.email_default,

      // Handle emails from PatDetails
      email: [
        { email: PatDetails.email, type: "Work" },
        { email: PatDetails.email_direct, type: "Home" },
      ].filter((item) => item.email || item.type),
      // Add phone data from PatDetails (adjust property names as needed)
      phone: [
        {
          phone: PatDetails.phone,
          type: "primary",
          code: PatDetails.phone_code,
        },
        {
          phone: PatDetails.phone_home,
          type: "Home",
          code: PatDetails.phone_home_code,
        },
        {
          phone: PatDetails.phone_biz,
          type: "Work",
          code: PatDetails.phone_biz_code,
        },
        {
          phone: PatDetails.phone_contact,
          type: "Contact",
          code: PatDetails.phone_contact_code,
        },
        {
          phone: PatDetails.phone_cell,
          type: "Mobile",
          code: PatDetails.phone_cell_code,
        },
      ].filter((item) => item.phone), // Filter out empty phone numbers
    };

    const changes = getFormChanges(currentFormState, originalState);

    // Compare phone lists and add to changes if there are differences
    const phoneChanges = comparePhoneLists(
      currentFormState.phone,
      originalPhoneList,
    );
    if (phoneChanges.length > 0) {
      changes.phone = phoneChanges;
    } else {
      delete changes.phone;
    }

    const onlyPhone =
      Object.keys(changes).length === 1 && Object.hasOwn(changes, "phone");

    if (
      onlyPhone &&
      changes.phone.length === 1 &&
      changes.phone[0].value === ""
    ) {
      toast(<Error msg="No changes were made to save." />, {
        containerId: "B",
        className: "error_badge",
      });
      return;
    }

    if (Object.keys(changes).length === 0) {
      toast(<Error msg="No changes were made to save." />, {
        containerId: "B",
        className: "error_badge",
      });
      return;
    }
    // Proceed with validation if changes exist
    let error = [];

    if (fname === "") {
      seterr(true);
      error = 2;
    }
    if (lname === "") {
      seterr1(true);
      error = 2;
    }
    // if (ssnErr) {
    //   error = 2;
    // }
    // if (suffixerr) {
    //   error = 2;
    // }
    // if (street === "") {
    //   setStreetErr(true);
    //   error = 2;
    // }
    // if (city === "") {
    //   setCityErr(true);
    //   error = 2;
    // }
    // if (country_code === "") {
    //   setZipErr(true);
    //   error = 2;
    // }
    if (sex1 === "") {
      setgenderErr(true);
      error = 2;
    }
    // if (status1 === "") {
    //   setstatusErr(true);
    //   error = 2;
    // }

    // if (ethnicity1 === "") {
    //   setraceErr(true);
    //   error = 2;
    // }

    // if (ethnicity2 === "") {
    //   setethniErr(true);
    //   error = 2;
    // }
    if (fromdate === "" || fromdate === null) {
      setdobErr(true);
      error = 2;
    }
    // if (state === "") {
    //   setstateErr(true);
    //   err = 4;
    // }
    // if (countryCodeErr) {
    //   error = 2;
    //   mobileRef.current.scrollIntoView({ behavior: "smooth" });
    // }
    const Errors = JSON.parse(JSON.stringify(validation));
    for (let i = 0; i < inputList2.length; i++) {
      if (inputList2[i].email === "") {
        Errors[i]["emailErr"] = true;
        Errors[i]["msg"] = "Enter the Mail ID";
        setValidation(Errors);

        error = 2;
      }
    }
    const Errors1 = JSON.parse(JSON.stringify(Errors));
    for (let i = 0; i < inputList2.length; i++) {
      if (inputList2[i].type === "") {
        Errors1[i]["typeErr"] = true;
        Errors1[i]["typemsg"] = "Select the Mail Type";
        setValidation(Errors1);
        error = 2;
      }
    }

    const allEmailErrorsFalse = validation.every(
      (obj) => obj.emailErr === false && obj.typeErr === false,
    );

    if (!allEmailErrorsFalse) {
      error = 2;
    }
    let worKMailCheck = false;
    for (let i = 0; i < inputList2.length; i++) {
      if (inputList2[i].type === "Work" || inputList2[i].type === "Home") {
        worKMailCheck = true;
        break;
      }
    }
    if (worKMailCheck === false) {
      setWorkMailErr(true);
      error = 6;
    } else {
      setWorkMailErr(false);
    }

    if (error > 0) {
      return false;
    }
    // ===== DEBUG: Console log phone data for comparison =====
    console.log("===== PHONE DEBUG START =====");
    console.log("Current Form Phone Data (currentFormState.phone):", JSON.stringify(currentFormState.phone, null, 2));
    console.log("Original Phone List (originalPhoneList):", JSON.stringify(originalPhoneList, null, 2));
    console.log("inputList (raw):", JSON.stringify(inputList, null, 2));
    console.log("Phone Changes detected:", JSON.stringify(phoneChanges, null, 2));
    console.log("All Changes:", JSON.stringify(changes, null, 2));
    const getPhoneListForApi = () => inputList.map(item => {
      let finalCodeText = item.codeText || "";
      if (!finalCodeText && item.code) {
        finalCodeText = getMainRegionForCode(item.code);
        if (!finalCodeText) {
          const match = countries.find((c) => c.dialCode === item.code);
          finalCodeText = match ? match.iso : "";
        }
      }
      return {
        ...item,
        type: item.type ? item.type.toLowerCase() : "",
        codeText: finalCodeText
      };
    });

    console.log("Article phone (what would be sent):", JSON.stringify(
      getPhoneListForApi(),
      null, 2
    ));
    console.log("===== PHONE DEBUG END =====");

    const article = {
      fname: fname,
      mname: mname,
      lname: lname,
      title: title,
      ss: ss,
      email: inputList2.map(item => ({ ...item, type: item.type ? item.type.toLowerCase() : "" })),
      phone: getPhoneListForApi(),
      street: street,
      city: city,
      active: active,
      state: state,
      postal_code: country_code,
      sex: sex1,
      pronoun: pronoun,
      sexual_orientation: sexualOrientation,
      age: age,
      gender_identity: genderIdentity,
      religious_affiliation: religiousAffiliation,
      interpreter: interpreterRequired ? 1 : 0,
      annual_family_income: annualFamilyIncome,
      pname: preferredName,
      providerID: providerID,
      status: status,
      language: language1,
      race: ethnicity1,
      ethnicity: ethnicity2,
      dob: fromdate,
      defaultEmailVal: defaltEmailType,
      // defaultMobileVal: defaltPhoneType,
      faxNumber: faxNumber,
      address_line_2: addressLine2,
      county: county,
      date_first_seen: dateFirstSeen,
      pcp_release: pcpRelease,
      hippaSigned: hippaSigned,
      roiSigned: roiSigned,
      patientTitle: suffix,
      suffix: suffix,
      pcp: pcp,
      defaultMobileVal: handlePhoneType() ? handlePhoneType().toLowerCase() : "",
      changes: changes,
    };
    dispatch(GetPatientDetailUpdate(article));
  };

  async function makeClientCrop(crop) {
    if (imageRef && crop.width && crop.height) {
      setNormalImg(false);
      const ImageUrl = await getCroppedImg(imageRef, crop, "newFile.jpeg");
      setcroppedImageUrl(ImageUrl);
    } else {
      setNormalImg(true);
    }
  }
  const ssChange = (e) => {
    let inputValue = e.target.value;
    if (inputValue.includes(" ")) return;
    let numericValue = inputValue.replace(/[^\d]/g, "");
    setssvalue(numericValue);
    if (numericValue.length <= 9) {
      let formattedSSN = numericValue.replace(
        /^(\d{3})(\d{2})(\d{4})$/,
        "$1-$2-$3",
      );

      setss(formattedSSN);
    }

    if (numericValue.length < 9) {
      setSSNErr(true);
    } else {
      setSSNErr(false);
    }
  };

  const getCroppedImg = (sourceImage, crop, fileName) => {
    const canvas = document.createElement("canvas");
    const pixelRatio = window.devicePixelRatio;
    const scaleX = sourceImage.naturalWidth / sourceImage.width;
    const scaleY = sourceImage.naturalHeight / sourceImage.height;
    const ctx = canvas.getContext("2d");
    canvas.width = crop.width * pixelRatio * scaleX;
    canvas.height = crop.height * pixelRatio * scaleY;

    ctx.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0);
    ctx.imageSmoothingQuality = "high";
    ctx.drawImage(
      sourceImage,
      crop.x * scaleX,
      crop.y * scaleY,
      crop.width * scaleX,
      crop.height * scaleY,
      0,
      0,
      crop.width * scaleX,
      crop.height * scaleY,
    );

    setjpegFile(canvas.toDataURL("image/jpeg"));
    return new Promise((resolve, reject) => {
      let fileUrl;
      canvas.toBlob(
        (blob) => {
          if (!blob) {
            reject(new Error("Canvas is empty"));
            return;
          }
          blob.name = fileName;
          window.URL.revokeObjectURL(fileUrl);
          fileUrl = window.URL.createObjectURL(blob);
          resolve(fileUrl);
        },
        "image/jpeg",
        1,
      );
    });
  };
  const mouseClick = () => {
    setShowOptions(true);
  };

  const HandleInputMobileType = (e, index, prevType) => {
    const phoneErrs = [...phoneValidation];
    phoneErrs[index]["typeErr"] = false;
    phoneErrs[index]["typemsg"] = "";
    setPhoneValidation(phoneErrs);

    const { value } = e.target; // Extract the value from the event
    setSelectedOptions([...selectedOptions, value]);
    const list = [...inputList];
    list[index]["type"] = value; // Assign the selected value to the list
    setInputList(list);
    if (prevType?.toLowerCase() === defaltPhoneType?.toLowerCase()) {
      setDefaltPhoneType(value);
    }
    setSelectedOptions(list);
  };

  const DropdownOptionList = [
    {
      title: "Hispanic or Latino",
      id: "1",
      Key: "Hispanic or Latino",
      value: "Hispanic or Latino",
    },
    {
      title: "Not Hispanic or Latino",
      id: "2",
      Key: "Not Hispanic or Latino",
      value: "Not Hispanic or Latino ",
    },
    {
      title: "Declined to specify",
      id: "3",
      Key: "Declined to specify",
      value: "Declined to specify ",
    },
    {
      title: "Prefer not to say",
      id: "4",
      Key: "Prefer not to say",
      value: "Prefer not to say",
    },
  ];
  const Toggling = () => setDropDown((prevState) => !prevState);
  const Toggling1 = () => setDropDown1((prevState) => !prevState);
  const Toggling2 = () => setDropDown2((prevState) => !prevState);
  const Toggling3 = () => setDropDown3((prevState) => !prevState);
  const Toggling4 = () => setDropDown4((prevState) => !prevState);
  const Toggling5 = () => {
    setDropDown5((prevState) => !prevState);
    setTooltipVisible(false);
  };
  const setsexselect = (r) => {
    setsex1(r.title);
    setDropDown(false);
  };
  const setmaritalselect = (r) => {
    setstatus1(r.title);
    setstatus(r.option_id);
    setDropDown1(false);
  };
  const setlanguageselect = (r) => {
    setlanguage1(r.title);
    setDropDown2(false);
  };

  const setraceselect = (r) => {
    setethnicity1(r.title);
    setDropDown3(false);
  };

  const setethinicityselect = (r) => {
    setethnicity2(r.title);
    setDropDown4(false);
  };
  const setstateselect = (s) => {
    setstate(s.option_id);
    setDropDown5(false);
    setTooltipVisible(false);
  };

  const handleMouseEnter = () => {
    setTooltipVisible(true);
  };

  const handleMouseLeave = () => {
    setTooltipVisible(false);
  };
  const HandleRemoveMobile = (index, PrevType) => {
    const list = [...inputList];
    list.splice(index, 1);
    setInputList(list);
    setSelectedOptions(list);
    const errors = JSON.parse(JSON.stringify(phoneValidation));
    errors.splice(index, 1);
    if (PrevType?.toLowerCase() === defaltPhoneType?.toLowerCase() && index !== 0) {
      setDefaltPhoneType(inputList[0].type);
    } else if (PrevType?.toLowerCase() === defaltPhoneType?.toLowerCase() && index === 0) {
      setDefaltPhoneType(inputList[1].type);
    } else if (index === 0) {
      setDefaltPhoneType(inputList[1].type);
    }
    setPhoneValidation(errors);
  };
  const handleClick = (e) => {
    if (inputNotRef.current && !inputNotRef.current.contains(e.target)) {
      setDropDown(false);
    }
  };
  const handleClick1 = (e) => {
    if (maritalNotRef.current && !maritalNotRef.current.contains(e.target)) {
      setDropDown1(false);
    }
  };
  const handleClick2 = (e) => {
    if (languageNotRef.current && !languageNotRef.current.contains(e.target)) {
      setDropDown2(false);
    }
  };
  const handleClick3 = (e) => {
    if (raceNotRef.current && !raceNotRef.current.contains(e.target)) {
      setDropDown3(false);
    }
  };
  const handleClick4 = (e) => {
    if (
      ethinicity2NotRef.current &&
      !ethinicity2NotRef.current.contains(e.target)
    ) {
      setDropDown4(false);
    }
  };
  const handleClick5 = (e) => {
    if (stateNotRef.current && !stateNotRef.current.contains(e.target)) {
      setDropDown5(false);
    }
  };
  const HandleInputEmail = (e, index) => {
    setMailcheck(e.target.value);
    setHoldSave(true);
    let values = false, msg = "";
    const mailRegex = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/;

    if (mailRegex.test(e.target.value)) {
      const isDuplicate = inputList2.some((item, idx) => idx !== index && item?.email === e.target.value);
      if (isDuplicate) {
        msg = "You are Entering the Duplicate Email";
        values = true;
      } else {
        values = false;

        optimizedFn(e.target.value);
      }
    } else {
      values = true;
      msg = "Enter the Valid Mail ID";
    }
    setHoldSave(false);

    setRowId(index);
    const { name, value } = e.target;
    const list = [...inputList2];
    list[index][name] = value;
    setInputList2(list);
    setSelectedOptions2(list);

    const Errors = JSON.parse(JSON.stringify(validation));
    if (!values) {
      Errors.forEach(err => {
        err["emailErr"] = values;
        err["msg"] = msg;
      });
    } else {
      if (Errors[index]) {
        Errors[index]["emailErr"] = values;
        Errors[index]["msg"] = msg;
      }
    }
    if (e.target.value === "") {
      Errors[index]["emailErr"] = false;
      Errors[index]["msg"] = "";
      setValidation(Errors);
      return;
    }
    setValidation(Errors);
  };
  const HandleInputEmailType = (e, index, PrevType) => {
    const { value } = e.target;
    setSelectedOptions2([...selectedOptions, value]);
    const list = [...inputList2];
    list[index]["type"] = value;

    setInputList2(list);
    setSelectedOptions2(list);

    if (value === "Work" || value === "Home") {
      setWorkMailErr(false);
    }

    const Errors = JSON.parse(JSON.stringify(validation));
    Errors[index]["typemsg"] = "";
    Errors[index]["typeErr"] = false;
    if (PrevType === defaltEmailType) {
      setDefaltEmailType(value);
    }
    setValidation(Errors);
    setInputList2(list);
    setSelectedOptions2(list);
  };

  const HandleRemoveEmail = (index, PrevType) => {
    const list = [...inputList2];
    list.splice(index, 1);
    setInputList2(list);
    setSelectedOptions2(list);
    const errors = JSON.parse(JSON.stringify(validation));
    errors.splice(index, 1);
    if (PrevType === defaltEmailType) {
      if (index === 0) {
        setDefaltEmailType(inputList2[1].type);
      } else {
        setDefaltEmailType(inputList2[0].type);
      }
    }
    setValidation(errors);
  };

  const splitPhoneNumber = (phoneNumber) => {
    // const match = phoneNumber?.match(/^(\+\d+)\s*(\d+.*)$/);

    if (phoneNumber) {
      const countryCode = `${phoneNumber[0]}`;
      const remainingNumber = phoneNumber[1];

      return {
        countryCode,
        remainingNumber,
      };
    }
    return {
      countryCode: "",
      remainingNumber: "",
    };
  };

  const setPhoneNumbers = (
    work,
    home,
    contact,
    mobile,
    work_code,
    home_code,
    contact_code,
    mobile_code,
  ) => {
    console.log("DEBUG PatDetails Input:", { work, work_code, mobile, mobile_code });
    var Mobile1;
    var Home1;
    var Contact1;
    var Work1;
    work = (work || "").replace(/\s+/g, "").replace(/[^a-zA-Z0-9+_]/g, "");
    home = (home || "").replace(/\s+/g, "").replace(/[^a-zA-Z0-9+_]/g, "");
    contact = (contact || "").replace(/\s+/g, "").replace(/[^a-zA-Z0-9+_]/g, "");
    mobile = (mobile || "").replace(/\s+/g, "").replace(/[^a-zA-Z0-9+_]/g, "");

    axios
      .get(backurl + "/interface/register/get_country_code_rpm.php")
      .then((res) => {
        const countryCodesForFilter = res.data;

        // Helper function to process phone numbers
        const processPhoneNumber = (phoneNumber, countryCode) => {
          if (phoneNumber.includes("_") && phoneNumber.startsWith("+")) {
            return phoneNumber;
          } else if (
            !phoneNumber.includes("_") &&
            phoneNumber.startsWith("+") &&
            countryCode !== "" &&
            countryCode !== null &&
            phoneNumber !== ""
          ) {
            const match = countryCodesForFilter.find(
              (item) => item.country === countryCode,
            );
            const number = match ? match.number : "";
            const codeStr = number.toString();
            const CodeFull = codeStr ? "+" + codeStr : "";
            const NumberFull = codeStr ? phoneNumber.slice(1 + codeStr.length) : phoneNumber;
            return CodeFull + "_" + NumberFull + "_" + countryCode;
          } else if (
            !phoneNumber.includes("_") &&
            phoneNumber.startsWith("+") &&
            (countryCode === "" || countryCode === null) &&
            phoneNumber !== ""
          ) {
            const cleanednumber = phoneNumber.startsWith("+")
              ? phoneNumber.slice(1)
              : phoneNumber;
            return `_${cleanednumber}_`;
          } else {
            return `_${phoneNumber}_`;
          }
        };

        // Process all phone numbers
        Mobile1 = processPhoneNumber(mobile, mobile_code);
        Home1 = processPhoneNumber(home, home_code);
        Contact1 = processPhoneNumber(contact, contact_code);
        Work1 = processPhoneNumber(work, work_code);

        // Helper function to split and extract phone data
        const extractPhoneData = (processedPhone, originalCode) => {
          const parts = processedPhone.split("_");
          return {
            countryCode: parts[0] || "",
            remainingNumber: parts[1] || "",
            codeText: parts[2] || originalCode || "",
          };
        };

        const workData = extractPhoneData(Work1, work_code);
        const homeData = extractPhoneData(Home1, home_code);
        const contactData = extractPhoneData(Contact1, contact_code);
        const mobileData = extractPhoneData(Mobile1, mobile_code);

        // Helper function to create phone entry
        const createPhoneEntry = (type, phoneData) => {
          let phoneVal = phoneData.remainingNumber || "";
          let codeVal = phoneData.countryCode || "";
          let codeTextVal = phoneData.codeText || "";

          // Clean up double plus signs that might have been added
          if (phoneVal.startsWith("++")) {
            phoneVal = phoneVal.substring(1);
          }
          if (phoneVal.startsWith("++")) {
            phoneVal = phoneVal.substring(1); // just in case
          }

          // If phone still starts with "+", it means the country code is embedded in it
          // Let's use google-libphonenumber to parse it correctly
          if (phoneVal.startsWith("+")) {
            try {
              const parsed = phoneUtil.parse(phoneVal);
              codeVal = "+" + parsed.getCountryCode();
              phoneVal = parsed.getNationalNumber().toString();
              codeTextVal = phoneUtil.getRegionCodeForNumber(parsed) || codeTextVal;
            } catch (e) {
              // Ignore and keep as is if unparseable
            }
          }

          return {
            phone: phoneVal,
            type: type,
            code: codeVal,
            codeText: codeTextVal,
          };
        };

        // Count non-empty phone numbers
        const phoneNumbers = [
          { number: mobile, data: mobileData, type: "Mobile" },
          { number: work, data: workData, type: "Work" },
          { number: home, data: homeData, type: "Home" },
          { number: contact, data: contactData, type: "Contact" },
        ].filter((item) => item.number !== "" && item.number !== undefined);

        if (phoneNumbers.length === 0) {
          setInputList(inputList);
          setSelectedOptions(inputList);
          setSelectedCode([]);
          return;
        }

        // Create phone list from non-empty numbers
        const PhoneNumList = phoneNumbers.map((item) =>
          createPhoneEntry(item.type, item.data),
        );

        // Create validation array for additional phone numbers (excluding the first one)
        const validationEntries = Array(Math.max(0, phoneNumbers.length - 1))
          .fill()
          .map(() => ({
            numberErr: false,
            typeErr: false,
            msg: "",
            typemsg: "",
          }));

        setPhoneValidation([...phoneValidation, ...validationEntries]);
        setOriginalPhoneList(PhoneNumList.map(item => ({ ...item })));
        setInputList(PhoneNumList);
        setSelectedOptions(PhoneNumList);

        const selectedCodeArr = PhoneNumList.map((item) => item.code !== "");
        setSelectedCode(selectedCodeArr);
      })
      .catch((err) => {
        console.error(err);
        setCountryCodes([]);
      });
  };

  const updateprofilestatustimeout = (alertData) => {
    if (alertData !== "0") {
      setupdateprofilestatus(0);
      dispatch(Getprofileupdatestatus("profile"));
      dispatch(GetUserDetails());
    }
  };

  const setEmails = (work, home) => {
    if (
      work !== "" &&
      work !== undefined &&
      home !== "" &&
      home !== undefined
    ) {
      const EmailList = [
        { email: "", type: "Work" },
        { email: "", type: "Home" },
      ];
      EmailList[0]["email"] = work;
      EmailList[1]["email"] = home;
      setInputList2(EmailList);
      setSelectedOptions2(EmailList);
      let val = { emailErr: false, typeErr: false, msg: "", typemsg: "" };
      setValidation([...validation, val]);
    } else if (work !== "" && home === "") {
      const EmailList = [{ email: "", type: "Work" }];

      EmailList[0]["email"] = work;
      setInputList2(EmailList);
      setSelectedOptions2(EmailList);
    } else if (work === "" && home !== "") {
      const EmailList = [{ email: "", type: "Home" }];

      EmailList[0]["email"] = home;
      setInputList2(EmailList);
      setSelectedOptions2(EmailList);
    } else if (work === "" && home === "") {
      setInputList2(inputList2);
      setSelectedOptions2(inputList2);
    }
  };

  const handleKeyPress = (e) => {
    const regex = /^[a-zA-Z]+$/;
    if (!regex.test(e.key)) {
      e.preventDefault();
    }
  };

  const handleKeyPress1 = (e) => {
    const ssnRegex = /^\d{3}-\d{2}-\d{4}$/;
    const inputValue = e.target.value.replace(/\D/g, ""); // Remove non-digit characters
    const formattedSSN = formatSSN(inputValue.slice(0, 9));
    setss(formattedSSN);
    if (ssnRegex.test(formattedSSN)) {
    } else {
    }
  };

  const formatSSN = (ssn) => {
    const cleanedSSN = ssn.replace(/\D/g, "");

    let formatted = cleanedSSN.slice(0, 3);

    if (cleanedSSN.length > 3) {
      formatted += "-" + cleanedSSN.slice(3, 5);
    }

    if (cleanedSSN.length > 5) {
      formatted += "-" + cleanedSSN.slice(5, 9);
    }

    return formatted;
  };
  const handleDefaultPhoneChange = (type) => {
    setDefaltPhoneType(type);
  };
  const handleDefaultEmailChange = (type) => {
    setDefaltEmailType(type);
  };
  useEffect(() => {
    axios
      .get(backurl + "/interface/register/get_country_code_rpm.php")
      .then((res) => {
        setCountryCodes(res.data);
      })
      .catch((err) => {
        console.error(err);
        setCountryCodes([]);
      });
  }, []);
  useEffect(() => {
    if (ssvalue && ssvalue.length < 9) {
      setSSNErr(true);
    } else {
      setSSNErr(false);
    }
  }, [ssvalue]);
  useEffect(() => {
    if (Refresh === 2) {
      Setshowpop1(false);
      setpreviewimg(null);
    }
  }, [Refresh]);

  useEffect(() => {
    let index = parseInt(rowId);
    if (mailChecking === "allowed") {
      const Errors = JSON.parse(JSON.stringify(validation));
      const mailRegex = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/;
      if (mailRegex.test(inputList2[index]["email"])) {
        Errors[index]["emailErr"] = false;
        Errors[index]["msg"] = "";
      } else {
        Errors[index]["emailErr"] = true;
        Errors[index]["msg"] = "Enter the Valid Mail ID";
      }
      setValidation(Errors);
      dispatch(SetEmailExist(""));
      setHoldSave(false);
    } else if (mailChecking === "exist") {
      const Errors = JSON.parse(JSON.stringify(validation));
      Errors[index]["emailErr"] = true;
      Errors[index]["msg"] = "Mail Id already Existed";
      setValidation(Errors);

      dispatch(SetEmailExist(""));
      setHoldSave(false);
    }
  }, [mailChecking, inputList2?.[rowId] && inputList2[rowId]["email"]]);

  useEffect(() => {
    let index = parseInt(phoneRowId);
    if (phoneChecking === "exist") {
      const Errors = JSON.parse(JSON.stringify(phoneValidation));
      Errors[index]["numberErr"] = true;
      Errors[index]["msg"] = "Phone Number already Existed";
      setPhoneValidation(Errors);

      dispatch(SetPhoneExist(""));
      setHoldSave(false);
    } else if (phoneChecking === "allowed") {
      dispatch(SetPhoneExist(""));
      setHoldSave(false);
    }
  }, [phoneChecking, inputList?.[phoneRowId] && inputList[phoneRowId]["phone"]]);

  const handleChange = (mailcheck) => {
    dispatch(GetEmailExist({ type: mailcheck }));
  };

  const optimizedFn = useCallback(debounce(handleChange), []);

  const handlePhoneChangeCheck = (phonecheck) => {
    dispatch(GetPhoneExist({ type: phonecheck }));
  };

  const optimizedPhoneFn = useCallback(debounce(handlePhoneChangeCheck), []);

  useEffect(() => {
    if (!PatDetails) return;
    setfname(PatDetails.fname);
    setmname(PatDetails.mname);
    setlname(PatDetails.lname);
    setTitle(PatDetails.title);
    setsuffix(PatDetails.suffix || PatDetails.patientTitle || "");
    setPronoun(PatDetails.pronoun || "");
    setSexualOrientation(PatDetails.sexual_orientation || "");
    setGenderIdentity(PatDetails.gender_identity || "");
    setReligiousAffiliation(PatDetails.religious_affiliation || "");
    setInterpreterRequired(PatDetails.interpreter == 1 ? true : false);
    setAnnualFamilyIncome(PatDetails.annual_family_income || "");
    setPreferredName(PatDetails.pname || "");
    setDateFirstSeen(PatDetails.date_first_seen || PatDetails.dateFirstSeen || "");
    setValidDateFirstSeen(PatDetails.date_first_seen || PatDetails.dateFirstSeen ? new Date(PatDetails.date_first_seen || PatDetails.dateFirstSeen) : "");
    setPcpRelease(PatDetails.pcp_release || PatDetails.pcpRelease || "");
    setFaxNumber(PatDetails.faxId || "");
    setActive(PatDetails.active);
    setss(PatDetails.ss);
    setstreet(PatDetails.street);
    setcity(PatDetails.city);
    setstate(PatDetails.state);
    setCounty(PatDetails.county);
    setAddressLine2(PatDetails.address_line_2)
    setDefaltPhoneType(PatDetails.phone_default);
    // console.log(PatDetails.email_default, "email.com");
    setDefaltEmailType(PatDetails.email_default);
    if (setstate) {
      constate.forEach((s) => {
        if (s.option_id === PatDetails.state || s.title === PatDetails.state) {
          setstate(s.title);
        }
      });
    }
    setcountry_code(PatDetails.postal_code);
    setFromDate(PatDetails.DOB);
    setsex1(PatDetails.sex);
    setethnicity1(PatDetails.race);
    setethnicity2(PatDetails.ethnicity);
    setlanguage1(PatDetails.language);
    setproviderID(PatDetails.providerID);
    setPcp(PatDetails.providerID);
    setstatus1(PatDetails.status);
    setstatus(PatDetails.status);
    if (PatDetails.status) {
      MaritalStatus.forEach((s) => {
        if (s.option_id === PatDetails.status) {
          setstatus1(s.title);
        }
      });
    }
    setpatimg(PatDetails.img_url);
    setupdateprofilestatus(PatDetails.update_profile_status);
    setRevertReason(PatDetails.revert_reason);
    // console.log(PatDetails, "fulldata");
    console.log("FULL PATDETAILS", PatDetails);
    setPhoneNumbers(
      PatDetails.phone_biz,
      PatDetails.phone_home,
      PatDetails.phone_contact,
      PatDetails.phone_cell,
      PatDetails.phone_biz_code,
      PatDetails.phone_home_code,
      PatDetails.phone_contact_code,
      PatDetails.phone_cell_code,
    );
    setshowsave(PatDetails.showsave);
    setEmails(PatDetails.email, PatDetails.email_direct);
    dispatch(SetEmailExist(""));
    setTimeout(
      () => updateprofilestatustimeout(PatDetails.update_profile_status),
      5000,
    );
  }, [constate, PatDetails]);

  useEffect(() => {
    document.addEventListener("mouseup", handleClick);
    document.addEventListener("mouseup", handleClick1);
    document.addEventListener("mouseup", handleClick2);
    document.addEventListener("mouseup", handleClick3);
    document.addEventListener("mouseup", handleClick4);
    document.addEventListener("mouseup", handleClick5);
    return () => {
      document.removeEventListener("mouseup", handleClick);
      document.removeEventListener("mouseup", handleClick1);
      document.removeEventListener("mouseup", handleClick2);
      document.removeEventListener("mouseup", handleClick3);
      document.removeEventListener("mouseup", handleClick4);
      document.removeEventListener("mouseup", handleClick5);
    };
  }, []);

  useEffect(() => {
    if (show) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }

    return () => {
      document.body.style.overflow = "auto";
    };
  }, [show]);

  return (
    <>
      <Display display="flex" alignItems="center" mt="24px">
        {/* {PatDetails.img_url === null ? (
          <Div
            border="1.5px solid #e9eef9"
            position="relative"
            height="70px"
            width="70px"
            minWidth="70px"
            minHeight="70px"
            borderRadius="50%"
            marginRight="20px"
            padding="4px"
          >
            <CurveImg
              position="absolute"
              top="-0.5px"
              left="38px"
              width="30px"
              height="30px"
              src={BlueCurve}
            />
            <Div
              background="#A8AEBE"
              height="100%"
              width="100%"
              borderRadius="50%"
              display="flex"
              alignItems="center"
              justifyContent="center"
              color="#FFFFFF"
              fontSize="24px"
              fontWeight="600"
            >
              {PatDetails.initials}
            </Div>
          </Div>
        ) : (
          <Div
            border="1.5px solid #e9eef9"
            position="relative"
            height="70px"
            width="70px"
            minWidth="70px"
            minHeight="70px"
            borderRadius="50%"
            marginRight="20px"
            padding="4px"
          >
            <CurveImg
              position="absolute"
              top="-0.5px"
              left="38px"
              width="30px"
              height="30px"
              src={BlueCurve}
            />
            <NormalImage
              loading="lazy"
              height="100%"
              width="100%"
              borderRadius="50%"
              src={File_URL + patimg}
            />
          </Div>
        )} */}
        {/* <Display display="inline">
          <Text
            fontSize="24px"
            fontWeight="700"
            color="#000000"
            mb="12px"
            lineHeight="33px"
            textAlign="left"
          >
            {fname} {lname}
          </Text>
          <Text
            fontFamily="Inter"
            fontWeight="400"
            fontSize="14px"
            color="#000000"
            lineHeight="23px"
            textAlign="left"
            mb="0px"
          >
            Set up your Patient Portal
          </Text>
        </Display> */}
      </Display>

      {UpdateStatus === "1" ? (
        <Displayerror
          display="flex"
          background="#77E0B5"
          width="100%"
          alignItems="center"
          pt="10px"
          pb="10px"
          justifyContent="center"
          color="#FFFFFF"
          mb="24px"
        >
          Profile updated successfully
        </Displayerror>
      ) : (
        <>
          {UpdateStatus === "2" ? (
            <Displayerror
              background="#FF7676"
              width="100%"
              alignItems="center"
              pt="10px"
              pb="10px"
              justifyContent="center"
              mb="24px"
            >
              <DisplayerrorText
                fontFamily="'Inter'"
                fontWeight="600"
                fontSize="16px"
                lineHeight="19px"
                textAlign="center"
                color="#ffffff"
              >
                Profile updated was Revert
              </DisplayerrorText>
              <DisplayerrorText
                fontFamily="Work Sans"
                fontWeight="500"
                fontSize="14px"
                lineHeight="20px"
                textAlign="center"
                color="#ffffff"
                mt="4px"
              >
                {revertReason}
              </DisplayerrorText>
            </Displayerror>
          ) : (
            <></>
          )}
        </>
      )}
      <Display display="flex" mb="24px">
        {croppedImageUrl ? (
          <Div
            height="60px"
            width="60px"
            marginRight="20px"
            marginLeft="3px"
            border="2px solid #D3D3D3"
            borderRadius="50%"
          >
            <NormalImage
              loading="lazy"
              height="100%"
              width="100%"
              borderRadius="50%"
              src={croppedImageUrl}
            />
          </Div>
        ) : patimg === null ? (
          <Div
            background="#A8AEBE"
            height="60px"
            width="60px"
            borderRadius="50%"
            display="flex"
            alignItems="center"
            justifyContent="center"
            marginRight="20px"
            border="2px solid #D3D3D3"
            color="#FFFFFF"
            fontSize="24px"
            fontWeight="600"
          >
            {PatDetails.initials}
          </Div>
        ) : (
          <Div
            height="60px"
            width="60px"
            marginRight="20px"
            marginLeft="3px"
            border="2px solid #D3D3D3"
            borderRadius="50%"
          >
            <NormalImage
              loading="lazy"
              height="100%"
              width="100%"
              borderRadius="50%"
              src={File_URL + patimg}
            />
          </Div>
        )}
        <Div display="flex" alignItems="center" justifyContent="center">
          {select && (
            <>
              <Display>
                <Display display="flex">
                  <Button
                    padding="12px 20px"
                    background="#2C7BE5"
                    hoverBackColor="#005FB2"
                    borderRadius="8px"
                    fontWeight="500"
                    fontSize="16px"
                    color=" #FFFFFF"
                    lineHeight="16px"
                    marginRight="16px"
                    className="save_active"
                    disabled={savepicbtndisabled}
                    onClick={UploadProfilePicture}
                  >
                    Save Picture
                  </Button>
                  <Button
                    color="#2C7BE5"
                    background="#FFF"
                    hoverBackColor="rgba(244, 246, 249, 0.75)"
                    border="1px solid #2C7BE5"
                    borderRadius="4px"
                    fontFamily="'Inter',sans-serif"
                    padding="12px 16px"
                    fontWeight="600"
                    fontSize="14px"
                    lineHeight="17px"
                    onClick={CloseFile}
                    disabled={uploadbtndisabled}
                  >
                    Cancel
                  </Button>
                </Display>
              </Display>
            </>
          )}

          {upload && (
            <>
              <Button
                padding="12px 20px"
                borderRadius="8px"
                background="#2C7BE5"
                hoverBackColor="#005FB2"
                fontWeight="500"
                lineHeight="16px"
                fontSize="16px"
                color="#FFFFFF"
                marginRight="23px"
                onClick={UploadFile}
                className="save_active"
                disabled={uploadbtndisabled}
              >
                Upload New Picture
              </Button>
              {patimg !== null && (
                <Button
                  padding="12px 18px"
                  background="#e7e7e9"
                  borderRadius="8px"
                  fontFamily="'Inter',sans-serif"
                  fontWeight="600"
                  fontSize="14px"
                  lineHeight="17px"
                  color="#000000"
                  onClick={() => {
                    Setshowpop1(true);
                  }}
                >
                  Delete
                </Button>
              )}
            </>
          )}
        </Div>
      </Display>

      <Form>
        <Display display="flex" mb="20px">
          <FormGroup display="grid" width="23%" marginRight="23px">
            <FormLabel
              fontFamily="'Inter',san-serif"
              fontSize="14px"
              lineHeight="17px"
              color="#2d3748"
              marginBottom="8px"
              textAlign="left"
            >
              First Name{" "}
              <span style={{ color: "red", fontSize: "16px" }}>*</span>
            </FormLabel>

            <Inputbox
              height="32px"
              background="#ffffff"
              border={err ? "1px solid red" : "1px solid #cbd5e0"}
              borderRadius="4px"
              paddingLeft="12px"
              placeholder="Enter First Name"
              value={fname}
              onChange={(e) => {
                setfname(e.target.value);
                seterr(false);
              }}
              onKeyPress={handleKeyPress}
              id="edPf_inp-fnm"
            />
            {err && (
              <Text
                textAlign="left"
                color="red"
                fontSize="10px"
                fontWeight="400"
                mb="0px"
                mt="0px"
              >
                Enter the First Name
              </Text>
            )}
          </FormGroup>

          <FormGroup display="grid" width="23%" marginRight="23px">
            <FormLabel
              fontFamily="Inter"
              fontWeight="400"
              fontSize="14px"
              lineHeight="17px"
              color="#2d3748"
              marginBottom="8px"
              textAlign="left"
            >
              Middle Name
            </FormLabel>
            <Inputbox
              height="32px"
              background="#ffffff"
              border="1px solid #cbd5e0"
              borderRadius="4px"
              paddingLeft="12px"
              placeholder="Enter Middle Name"
              value={mname}
              onChange={(e) => setmname(e.target.value)}
              onKeyPress={handleKeyPress}
              id="edPf_inp-mdnm"
            />
          </FormGroup>

          <FormGroup display="grid" width="23%" marginRight="23px">
            <FormLabel
              fontFamily="Inter"
              fontWeight="400"
              fontSize="14px"
              lineHeight="17px"
              color="#2d3748"
              marginBottom="8px"
              textAlign="left"
            >
              Last Name{" "}
              <span style={{ color: "red", fontSize: "16px" }}>*</span>
            </FormLabel>
            <Inputbox
              height="32px"
              background="#ffffff"
              border={err1 ? "1px solid red" : "1px solid #cbd5e0"}
              borderRadius="4px"
              paddingLeft="12px"
              value={lname}
              onChange={(e) => {
                setlname(e.target.value);
                seterr1(false);
              }}
              onKeyPress={handleKeyPress}
              id="edPf_inp-lstnm"
            />
            {err1 ? (
              <Text
                textAlign="Left"
                color="red"
                fontSize="10px"
                fontWeight="400"
                mb="0px"
                mt="0px"
              >
                Enter the Last Name
              </Text>
            ) : (
              ""
            )}
          </FormGroup>

          <FormGroup display="grid" width="23%">
            <FormLabel
              fontFamily="Inter"
              fontWeight="400"
              fontSize="14px"
              lineHeight="17px"
              color="#2d3748"
              marginBottom="8px"
              textAlign="left"
            >
              Preferred Name
            </FormLabel>
            <Inputbox
              height="32px"
              background="#ffffff"
              border="1px solid #cbd5e0"
              borderRadius="4px"
              paddingLeft="12px"
              placeholder="Enter Preferred Name"
              value={preferredName}
              onChange={(e) => setPreferredName(e.target.value)}
              onKeyPress={handleKeyPress}
              id="edPf_inp-prfnnm"
            />
          </FormGroup>
        </Display>

        <Display display="flex" mb="20px" alignItems="start">
          <FormGroup display="grid" width="23%" marginRight="23px">
            <FormLabel
              fontFamily="Inter"
              fontWeight="400"
              fontSize="14px"
              lineHeight="17px"
              color="#2d3748"
              marginBottom="8px"
              textAlign="left"
            >
              Suffix
            </FormLabel>
            <Select
              popupClassName="custom-blue-select"
              virtual={false}
              getPopupContainer={(triggerNode) => triggerNode.parentNode}
              // placeholder="Select a title"
              suffixIcon={<CustomSuffixIcon />}
              name="suffix"
              id="setting_profile_suffix"
              value={suffix || undefined}
              onChange={(e) => {
                setsuffix(e);
              }}
              className="w-100"
            >
              <Option value="Sr.">Sr.</Option>
              <Option value="Jr.">Jr.</Option>
              <Option value="I">I</Option>
              <Option value="II">II</Option>
              <Option value="III">III</Option>
              <Option value="IV">IV</Option>
              <Option value="V">V</Option>
              <Option value="VI">VI</Option>
              <Option value="VII">VII</Option>
              <Option value="VIII">VIII</Option>
              <Option value="IX">IX</Option>
              <Option value="X">X</Option>
            </Select>
            {suffixerr && <ErrorMessage>Suffix Should be 7 digit</ErrorMessage>}
          </FormGroup>

          <FormGroup display="grid" width="23%" marginRight="23px">
            <FormLabel
              fontFamily="Inter"
              fontWeight="400"
              fontSize="14px"
              lineHeight="17px"
              color="#2d3748"
              marginBottom="8px"
              textAlign="left"
            >
              Title
            </FormLabel>
            <Select
              popupClassName="custom-blue-select"
              virtual={false}
              getPopupContainer={(triggerNode) => triggerNode.parentNode}
              // placeholder="Select a title"
              suffixIcon={<CustomSuffixIcon />}
              name="title"
              id="setting_profile_title"
              value={title || undefined}
              onChange={(e) => {
                setTitle(e);
              }}
              className="w-100"
            >
              <Option value="1" id="setting_profile_Option1">
                Mr.
              </Option>
              <Option value="2">Mrs.</Option>
              <Option value="3">Ms.</Option>
            </Select>
            {suffixerr && <ErrorMessage>Suffix Should be 7 digit</ErrorMessage>}
          </FormGroup>

          <div style={{ width: "23%", marginRight: "23px" }}>
            <FormGroup display="grid">
              <FormLabel
                fontFamily="Inter"
                fontWeight="400"
                fontSize="14px"
                lineHeight="17px"
                color="#2d3748"
                marginBottom="8px"
                textAlign="left"
              >
                SSN
              </FormLabel>
              <Inputbox
                height="32px"
                background="#ffffff"
                border={ssnErr ? "1px solid red" : "1px solid #cbd5e0"}
                borderRadius="4px"
                paddingLeft="12px"
                value={ss}
                onChange={ssChange}
                onKeyPress={handleKeyPress1}
                id="edPf_inp-ssvl"
              />
            </FormGroup>
            {ssnErr && <ErrorMessage>SSN Should be 9 digit</ErrorMessage>}
          </div>

          <FormGroup display="grid" width="23%">
            <FormLabel
              fontFamily="Inter"
              fontWeight="400"
              fontSize="14px"
              lineHeight="17px"
              color="#2d3748"
              marginBottom="8px"
              textAlign="left"
            >
              Primary Care Provider
            </FormLabel>
            <Select
              popupClassName="custom-blue-select"
              virtual={false}
              getPopupContainer={(triggerNode) => triggerNode.parentNode}
              placeholder="Select Provider"
              suffixIcon={<CustomSuffixIcon />}
              value={pcp || undefined}
              onChange={(e) => setPcp(e)}
              className="w-100"
            >
              {providersList && providersList.map && providersList.map((provider) => (
                <Option key={provider.id} value={provider.id}>
                  {provider.ProviderName || provider.name || `${provider.first_name} ${provider.last_name}`}
                </Option>

              ))}
            </Select>
          </FormGroup>
        </Display>

        <Hrline ml="-40px" mb="23px" />

        <Text
          fontWeight="500"
          fontSize="16px"
          marginBottom="8px"
          textAlign="left"
          color="#2D3748"
          fontFamily="'Inter',san-serif"
        >
          Phone
        </Text>
        <Div
          fontFamily="'Inter',san-serif"
          lineHeight="15px"
          color="#718096"
          marginBottom="12px"
          fontSize="12px"
        >
          If you want to send this client text or voice reminders, add their
          phone number(s).
        </Div>
        {inputList.map((x, ind) => (
          <>
            <FormGroup display="grid" key={ind} ref={mobileRef}>
              <FormLabel
                fontFamily="'Inter',san-serif"
                fontSize="14px"
                lineHeight="17px"
                color="#2d3748"
                marginBottom="8px"
                textAlign="left"
              >
                Phone Number
              </FormLabel>

              <Display display="flex" mb="12px">
                <Div
                  display="flex"
                  flexDirection="column"
                  width="25%"
                  minWidth="280px"
                  marginRight="24px"
                >
                  <PhoneInput
                    value={{
                      country: x.codeText ? countries.find((c) => c.iso === x.codeText) : (
                        countries.find((c) => c.iso === getMainRegionForCode(x.code)) ||
                        countries.find((c) => c.dialCode === x.code)
                      ),
                      number: x.phone,
                    }}
                    disabled={false}
                    onChange={(val) => {
                      const list = [...inputList];
                      list[ind]["phone"] = val.number;
                      list[ind]["code"] = val.country?.dialCode || "";
                      list[ind]["codeText"] = val.country?.iso || "";

                      setInputList(list);

                      handleInputChangeP(
                        `${val.country?.name}-${val.country?.dialCode}-${val.country?.iso}`,
                        ind
                      );

                      handleInputChangeP(
                        {
                          target: {
                            name: "phone",
                            value: val.number,
                          },
                        },
                        ind
                      );
                    }}
                    className={
                      phoneValidation[ind]?.numberErr || phoneValidation[ind]?.codeErr || (!phoneValidation[ind]?.numberErr && countryCodeErr)
                        ? "error-border"
                        : ""
                    }
                  />

                  {!phoneValidation[ind]?.numberErr && countryCodeErr && (
                    <Text
                      textAlign="left"
                      color="red"
                      fontSize="10px"
                      fontWeight="400"
                      mb="0px"
                      mt="0px"
                    >
                      Select a Country code from the dropdown
                    </Text>
                  )}
                  {phoneValidation[ind]?.numberErr === true ? (
                    <Text
                      textAlign="left"
                      color="red"
                      fontSize="10px"
                      fontWeight="400"
                      mb="0px"
                      mt="0px"
                      style={{ whiteSpace: "normal", wordWrap: "break-word" }}
                    >
                      {phoneValidation[ind]?.msg}
                    </Text>
                  ) : (
                    ""
                  )}
                </Div>
                <Div
                  display="flex"
                  flexDirection="column"
                  width="10%"
                  minWidth="140px"
                  marginRight="12px"
                >
                  <CustomDropdown
                    value={x.type}
                    onSelect={(value) =>
                      HandleInputMobileType({ target: { value } }, ind, x.type)
                    }
                    selectedOptions={selectedOptions}
                    width="100%"
                    height="35px"
                    options={[
                      { value: "", label: "Select", disabled: true },
                      {
                        value: "Mobile",
                        label: "Mobile",
                      },
                      {
                        value: "Work",
                        label: "Work",
                      },
                      {
                        value: "Home",
                        label: "Home",
                      },
                      {
                        value: "Contact",
                        label: "Contact",
                      },
                    ]}
                  />
                  {phoneValidation[ind]?.typeErr === true ? (
                    <Text
                      textAlign="left"
                      color="red"
                      fontSize="10px"
                      fontWeight="400"
                      mb="0px"
                      mt="0px"
                    >
                      {phoneValidation[ind]?.typemsg}
                    </Text>
                  ) : (
                    ""
                  )}
                </Div>

                {/* <div
                  className=""
                  style={{ marginLeft: "30px", marginTop: "5px" }}
                >
                  <input
                    type="radio"
                    onChange={() => handleDefaultPhoneChange(x.type)}
                    checked={x.type?.toLowerCase() === defaltPhoneType?.toLowerCase()}
                  />
                  <label style={{ marginLeft: "5px" }}>Default</label>
                </div> */}
                <div
                  className=""
                  style={{ marginLeft: "40px", marginTop: "5px" }}
                >
                  {/* {console.log(x)} */}
                  <input
                    type="radio"
                    onChange={() => handleDefaultPhoneChange(x.type)}
                    checked={x.type?.toLowerCase() === defaltPhoneType?.toLowerCase()}
                  />
                  <label style={{ marginLeft: "5px" }}>Default</label>
                </div>
                {inputList.length !== 1 && (
                  <AiOutlineDelete
                    style={{
                      marginLeft: "20px",
                      color: "red",
                      height: "20px",
                      width: "20px",
                      paddingTop: "3px",
                      cursor: "pointer",
                      marginTop: "2px",
                    }}
                    onClick={() => HandleRemoveMobile(ind, x.type)}
                  />
                )}
              </Display>
            </FormGroup>
            {inputList.length - 1 === ind && (
              <>
                {ind < 3 && (
                  <Button
                    disabled={!inputList[ind].phone || !inputList[ind].type}
                    height="32px"
                    fontFamily="'Inter',san-serif"
                    fontSize="14px"
                    lineHeight="17px"
                    color="#2066c2"
                    background="#ffffff"
                    border="1px solid #2C7BE5"
                    className="close_active"
                    hoverBackColor="rgba(244, 246, 249, 0.75)"
                    borderRadius="4px"
                    marginBottom="16px"
                    alignItems="center"
                    justifyContent="space-evenly"
                    display="flex"
                    padding="8px 12px"
                    onClick={(e) => {
                      e.preventDefault();
                      setInputList([
                        ...inputList,
                        { phone: "", type: "", code: "", codeText: "" },
                      ]);
                      setSearchText((prevSearchText) => [
                        ...prevSearchText,
                        "",
                      ]);
                      setSelectedOptions([
                        ...inputList,
                        { phone: "", type: "", code: "", codeText: "" },
                      ]);
                      setPhoneValidation([
                        ...phoneValidation,
                        {
                          numberErr: false,
                          typeErr: false,
                          msg: "",
                          typemsg: "",
                        },
                      ]);
                    }}
                    id="edPf_btn-adPh"
                  >
                    <AiOutlinePlus />
                    Add Phone
                  </Button>
                )}
              </>
            )}
          </>
        ))}

        <Hrline ml="-40px" mt="0px" mb="16px" />
        <Text
          fontWeight="500"
          fontSize="16px"
          marginBottom="9px"
          textAlign="left"
        >
          Email
        </Text>

        <Div
          fontFamily="'Inter',san-serif"
          fontSize="12px"
          lineHeight="15px"
          color="#718096"
          marginBottom="12px"
        >
          If you want to send this client email reminders or billing documents,
          and to grant them Client Portal access, add their email address.
        </Div>
        {inputList2.map((x, i) => {
          return (
            <>
              <Display display="inline" mb="20px" key={i}>
                <Text
                  fontFamily="'Inter',san-serif"
                  fontWeight="400"
                  fontSize="14px"
                  color="#2d3748"
                  marginBottom="8px"
                  textAlign="left"
                >
                  Email ID{" "}
                  <span style={{ color: "red", fontSize: "16px" }}>*</span>
                </Text>
                <Display display="flex" mb="12px">
                  <Div
                    display="flex"
                    flexDirection="column"
                    width="20%"
                    marginRight="12px"
                  >
                    <Tooltip>
                      <TooltipText className="TooltipText">
                        {x.email}
                      </TooltipText>
                      <Inputbox
                        name="email"
                        id={`email edPf_inp-mail_id${i}`}
                        height="32px"
                        width="100%"
                        background="#ffffff"
                        border={
                          (validation[i]?.emailErr && !workMailErr) ||
                            (workMailErr && inputList2.length - 1 !== i)
                            ? "1px solid red"
                            : "1px solid #cbd5e0"
                        }
                        borderRadius="4px"
                        paddingLeft="12px"
                        textOverflow="ellipsis"
                        value={x.email}
                        onChange={(e) => HandleInputEmail(e, i)}
                      />
                    </Tooltip>
                    {(validation[i]?.emailErr && !workMailErr) ||
                      (workMailErr && inputList2.length - 1 !== i) ? (
                      <Text
                        textAlign="left"
                        color="red"
                        fontSize="10px"
                        fontWeight="400"
                        mb="0px"
                        mt="0px"
                      >
                        {validation[i]?.msg}
                      </Text>
                    ) : (
                      ""
                    )}
                  </Div>
                  <Div
                    display="flex"
                    flexDirection="column"
                    width="10%"
                    marginRight="12px"
                  >
                    <CustomDropdown
                      value={x.type}
                      onSelect={(value) =>
                        HandleInputEmailType({ target: { value } }, i, x.type)
                      }
                      selectedOptions={selectedOptions2}
                      options={[
                        { value: "", label: "Select", disabled: true },
                        {
                          value: "Work",
                          label: "Work",
                        },
                        {
                          value: "Home",
                          label: "Home",
                        },
                      ]}
                    />
                    {(validation[i]?.typeErr === true && !workMailErr) ||
                      (workMailErr && inputList2.length - 1 !== i) ? (
                      <Text
                        textAlign="left"
                        color="red"
                        fontSize="10px"
                        fontWeight="400"
                        mb="0px"
                        mt="0px"
                      >
                        {validation[i]?.typemsg}
                      </Text>
                    ) : (
                      ""
                    )}
                  </Div>

                  {/* <div
                    className=""
                    style={{ marginLeft: "30px", marginTop: "5px" }}
                  >
                    <input
                      type="radio"
                      onChange={() => handleDefaultEmailChange(x.type)}
                      checked={x.type?.toLowerCase() === defaltEmailType?.toLowerCase()}
                    />
                    <label style={{ marginLeft: "5px" }}>Default</label>
                  </div> */}
                  <div
                    className=""
                    style={{ marginLeft: "40px", marginTop: "5px" }}
                  >
                    {/* {console.log(x, "ppa", defaltEmailType)} */}
                    <input
                      type="radio"
                      onChange={() => handleDefaultEmailChange(x.type)}
                      checked={x.type?.toLowerCase() === defaltEmailType?.toLowerCase()}
                    />
                    <label style={{ marginLeft: "5px" }}>Default</label>
                  </div>
                  {inputList2.length !== 1 && (
                    <AiOutlineDelete
                      style={{
                        marginLeft: "20px",
                        color: "red",
                        height: "20px",
                        width: "20px",
                        cursor: "pointer",
                        marginTop: "5px",
                      }}
                      onClick={() => HandleRemoveEmail(i, x.type)}
                    />
                  )}
                </Display>
              </Display>
              {workMailErr && inputList2.length - 1 === i && (
                <Display display="flex" mb="12px">
                  <Text
                    textAlign="left"
                    color="red"
                    fontSize="10px"
                    fontWeight="400"
                    mb="0px"
                    mt="0px"
                  >
                    {"Please add email of type work"}
                  </Text>
                </Display>
              )}

              {inputList2.length - 1 === i && (
                <>
                  {i < 1 && (
                    <Button
                      padding="8px 19px"
                      height="32px"
                      fontFamily="'Inter',san-serif"
                      fontWeight="400"
                      fontSize="14px"
                      lineHeight="17px"
                      color="#2066c2"
                      background="#ffffff"
                      border="1px solid #2C7BE5"
                      hoverBackColor="rgba(244, 246, 249, 0.75)"
                      borderRadius="4px"
                      marginBottom="20px"
                      alignItems="center"
                      justifyContent="space-evenly"
                      className="close_active"
                      display="flex"
                      onClick={(e) => {
                        e.preventDefault();
                        setInputList2([...inputList2, { email: "", type: "" }]);
                        setSelectedOptions2([
                          ...inputList2,
                          { email: "", type: "" },
                        ]);
                        setValidation([
                          ...validation,
                          {
                            emailErr: false,
                            typeErr: false,
                            msg: "",
                            typemsg: "",
                          },
                        ]);
                      }}
                      id="edPf_btn-add_emil"
                    >
                      <AiOutlinePlus />
                      Add Email
                    </Button>
                  )}
                </>
              )}
            </>
          );
        })}

        <Hrline ml="-40px" mt="0px" mb="16px" />

        <Text
          fontFamily="'Inter',san-serif"
          fontWeight="500"
          fontSize="16px"
          marginBottom="8px"
          textAlign="left"
        >
          Fax Number
        </Text>

        <Div
          fontFamily="'Inter',san-serif"
          fontSize="12px"
          lineHeight="15px"
          color="#718096"
          marginBottom="12px"
        >
          If you want to send this client documents or data, add their fax number.
        </Div>
        <FormGroup display="grid" marginBottom="12px">
          <Inputbox
            width="200px"
            height="32px"
            background="#ffffff"
            border="1px solid #cbd5e0"
            borderRadius="4px"
            paddingLeft="12px"
            value={faxNumber}
            onChange={(e) => setFaxNumber(e.target.value)}
          />
        </FormGroup>

        <Hrline ml="-40px" mt="0px" mb="16px" />

        <Text
          fontFamily="'Inter',san-serif"
          fontWeight="500"
          fontSize="16px"
          marginBottom="8px"
          textAlign="left"
        >
          Address
        </Text>

        <Div
          fontFamily="'Inter',san-serif"
          fontSize="12px"
          lineHeight="15px"
          color="#718096"
          marginBottom="12px"
        >
          If you want to receive billing documents, lab results enter your resident address.
        </Div>

        <FormGroup display="grid" marginBottom="12px">
          <FormLabel
            fontFamily="'Inter',san-serif"
            fontSize="14px"
            lineHeight="17px"
            color="#2d3748"
            marginBottom="8px"
            textAlign="left"
          >
            Street
          </FormLabel>
          <Inputbox
            width="620px"
            height="32px"
            background="#ffffff"
            border={streetErr ? "1px solid red" : "1px solid #cbd5e0"}
            borderRadius="4px"
            paddingLeft="12px"
            value={street}
            onChange={(e) => {
              setStreetErr(false);
              setstreet(e.target.value);
            }}
          />
        </FormGroup>
        {streetErr && <ErrorMessage>Enter a Street name</ErrorMessage>}
        <FormGroup display="grid" marginBottom="12px">
          <FormLabel
            fontFamily="'Inter',san-serif"
            fontSize="14px"
            lineHeight="17px"
            color="#2d3748"
            marginBottom="8px"
            textAlign="left"
          >
            Address line 2
          </FormLabel>
          <Inputbox
            width="620px"
            height="32px"
            background="#ffffff"
            border="1px solid #cbd5e0"
            borderRadius="4px"
            paddingLeft="12px"
            value={addressLine2}
            onChange={(e) => setAddressLine2(e.target.value)}
          />
        </FormGroup>
        <Display display="flex">
          <FormGroup display="flex" flexDirection="column" marginRight="10px">
            <FormLabel
              fontFamily="'Inter',san-serif"
              fontSize="14px"
              lineHeight="17px"
              color="#2d3748"
              marginBottom="8px"
              textAlign="left"
            >
              City
            </FormLabel>
            <Inputbox
              paddingLeft="12px"
              width="160px"
              height="32px"
              background="#ffffff"
              border={cityErr ? "1px solid red" : "1px solid #cbd5e0"}
              borderRadius="4px"
              value={city}
              onChange={(e) => {
                let a = /[0-9 ]/i.test(e.target.value);
                if ((isNaN(e.target.value) && !a) || e.target.value === "") {
                  setcity(e.target.value);
                  setCityErr(false);
                }
              }}
              id="my_pf-inp_cty"
            />
            {cityErr && <ErrorMessage>Enter a City name</ErrorMessage>}
          </FormGroup>

          <FormGroup display="flex" flexDirection="column" marginRight="10px">
            <FormLabel
              fontFamily="'Inter',san-serif"
              fontSize="14px"
              lineHeight="17px"
              color="#2d3748"
              marginBottom="0px"
              textAlign="left"
            >
              State
            </FormLabel>

            <Dropdownstyle marginTop="0px" ref={stateNotRef}>
              <Div
                onClick={Toggling5}
                onMouseEnter={handleMouseEnter}
                onMouseLeave={handleMouseLeave}
              >
                <SelectInput
                  width="100px"
                  height="32px"
                  background="#FFFFFF"
                  fontSize="14px"
                  name="sex"
                  fontFamily="Inter"
                  fontWeight="400"
                  letterSpacing="0.0025em"
                  color="#747474"
                  border={
                    stateErr ? "1px solid red" : "1px solid rgba(34,36,38,.15)"
                  }
                  borderRadius="4px"
                  padding="0px 12px"
                  value={state}
                  id="my_pf-inp_sta"
                >
                  <Div
                    width="72px"
                    textOverflow="ellipsis"
                    overflow="hidden"
                    whiteSpace="nowrap"
                    color="#747474"
                  >
                    {state || "Select"}
                  </Div>
                  <DropdownImage
                    height="7px"
                    width="10px"
                    top="11px"
                    right="6px"
                    src={arrowIcon}
                  ></DropdownImage>
                </SelectInput>
              </Div>
              {tooltipVisible ? (
                <TooltipComponent
                  marginTop="4px"
                  background="#f5f5f5"
                  color="rgb(45,55,72)"
                  height="auto"
                  width="auto"
                  fontSize="12px"
                  fontWeight="400"
                  border="1px solid rgba(0,0,0,0.125)"
                  borderRadius="4px"
                  padding="2px 10px 3px 10px"
                  backgroundClip="border-box"
                >
                  {state ? state : "Select"}
                </TooltipComponent>
              ) : null}
              {dropDown5 && constate.length > 0 ? (
                <DropDownDiv
                  width="100px"
                  background="#FFFFFF"
                  border=" 1px solid rgba(46, 46, 46, 0.25)"
                  borderRadius="4px"
                  maxHeight="225px"
                  overflowY="auto"
                  bottom="31px"
                >
                  {state !== "" && state !== null
                    ? constate.map((s, i) =>
                      s.option_id.toLowerCase() === state.toLowerCase() ? (
                        <DropdownOptions
                          padding="2px 1px 2px 1px"
                          fontSize="12px"
                          key={`3g${i}`}
                          value={s.option_id}
                          id={`adCon_sta${i}`}
                          onClick={() => {
                            setstateselect(s);
                            setstateErr(false);
                          }}
                        >
                          {s.title}
                        </DropdownOptions>
                      ) : (
                        <DropdownOptions
                          padding="2px 1px 2px 1px"
                          fontSize="12px"
                          key={`3g${i}`}
                          value={s.title}
                          id={`adCon_sta${i}`}
                          onClick={() => {
                            setstateselect(s);
                            setstateErr(false);
                          }}
                        >
                          {s.option_id}
                        </DropdownOptions>
                      ),
                    )
                    : constate.map((s, i) => (
                      <DropdownOptions
                        padding="2px 1px 2px 1px"
                        fontSize="12px"
                        key={`3g1${i}`}
                        value={s.title}
                        id={`adCon_sta${i}`}
                        onClick={() => {
                          setstateselect(s);
                          setstateErr(false);
                        }}
                      >
                        {s.option_id}
                      </DropdownOptions>
                    ))}
                </DropDownDiv>
              ) : (
                ""
              )}
            </Dropdownstyle>
            {stateErr && <ErrorMessage>Choose State</ErrorMessage>}
          </FormGroup>

          <FormGroup display="flex" flexDirection="column" marginRight="10px">
            <FormLabel
              fontFamily="'Inter',san-serif"
              fontSize="14px"
              lineHeight="17px"
              color="#2d3748"
              marginBottom="8px"
              textAlign="left"
            >
              Zip
            </FormLabel>
            <Inputbox
              width="100px"
              paddingLeft="12px"
              height="32px"
              background="#ffffff"
              border={zipErr ? "1px solid red" : "1px solid #cbd5e0"}
              borderRadius="4px"
              value={country_code}
              onChange={(e) => {
                const value = e.target.value;

                // Allow only digits, no dots, and max 5 characters
                if (/^\d{0,5}$/.test(value)) {
                  setZipErr(false);
                  setcountry_code(value);
                }
              }}
              id="my_pf-inp_zp"
            />
            {zipErr && <ErrorMessage>Enter a Zip code</ErrorMessage>}
          </FormGroup>

          <FormGroup display="flex" flexDirection="column">
            <FormLabel
              fontFamily="'Inter',san-serif"
              fontSize="14px"
              lineHeight="17px"
              color="#2d3748"
              marginBottom="8px"
              textAlign="left"
            >
              County
            </FormLabel>
            <Inputbox
              width="160px"
              paddingLeft="12px"
              height="32px"
              background="#ffffff"
              border="1px solid #cbd5e0"
              borderRadius="4px"
              value={county}
              onChange={(e) => setCounty(e.target.value)}
            />
          </FormGroup>
        </Display>

        <Hrline ml="-40px" mt="16px" mb="16px" />

        <Text
          fontFamily="'Inter',san-serif"
          fontWeight="500"
          fontSize="16px"
          marginBottom="12px"
          textAlign="left"
        >
          Clinical Info
        </Text>
        <Display display="flex">
          <FormGroup display="flex" flexDirection="column" marginRight="10px">
            <FormLabel
              fontFamily="'Inter',san-serif"
              fontSize="14px"
              lineHeight="17px"
              color="#2d3748"
              marginBottom="8px"
              textAlign="left"
            >
              Date First Seen
            </FormLabel>
            <Div
              display="flex"
              position="relative"
              width="150px"
              alignItems="center"
            >
              <CustomDatePicker
                id="CustomDatePicker_FirstSeen"
                width="150px"
                height="32px"
                backgroundColour="#ffffff"
                border="1px solid #cbd5e0"
                placeholder="MM-DD-YYYY"
                value={
                  dateFirstSeen !== "" && dateFirstSeen
                    ? moment(dateFirstSeen).format("MM-DD-YYYY")
                    : ""
                }
                onChange={(e) => {
                  let d = moment(e.target.value, "YYYY-MM-DD", true).isValid();
                  setDateFirstSeen(e.target.value);
                  if (e.target.value === "") {
                    setValidDateFirstSeen("");
                  } else if (d) {
                    setValidDateFirstSeen(e.target.value);
                  }
                }}
                onClick={(e) => {
                  setShowPickerFirstSeen(true);
                }}
                onKeyPress={(event) => {
                  if (
                    !/[0-9]/.test(event.key) ||
                    event.target.value.length > 9
                  ) {
                    event.preventDefault();
                  }
                }}
                onKeyDown={(e) => keyDownExpiry(e)}
                onResultSelect={(value) => {
                  if (Object.prototype.toString.call(value) === "[object Date]") {
                    setDateFirstSeen(moment(value).format("YYYY-MM-DD"));
                    setValidDateFirstSeen(new Date(value));
                  } else {
                    setDateFirstSeen("");
                    setValidDateFirstSeen("");
                  }
                  setShowPickerFirstSeen(false);
                }}
                showPicker={showPickerFirstSeen}
                validDate={validDateFirstSeen}
                closePicker={() => setShowPickerFirstSeen(false)}
                max={moment(new Date(), "DD/MM/YYYY")}
              ></CustomDatePicker>
              <Imagecalendar
                id="CustomDatePicker_FirstSeen_Icon"
                onClick={() => setShowPickerFirstSeen(true)}
                src={calendar_icon_custom}
              ></Imagecalendar>
            </Div>
          </FormGroup>
          <FormGroup display="flex" flexDirection="column" marginRight="10px">
            <FormLabel
              fontFamily="'Inter',san-serif"
              fontSize="14px"
              lineHeight="17px"
              color="#2d3748"
              marginBottom="8px"
              textAlign="left"
            >
              PCP Release
            </FormLabel>
            <Select
              popupClassName="custom-blue-select"
              placeholder="Select"
              value={pcpRelease || undefined}
              onChange={(e) => setPcpRelease(e)}
              style={{ width: 200 }}
            >
              <Option value="Not Set">Not Set</Option>
              <Option value="Patient consented to release information" disabled={!roiSigned}>Patient consented to release information</Option>
              <Option value="Patient declined to release information" disabled={!roiSigned}>Patient declined to release information</Option>
              <Option value="Not applicable">Not applicable</Option>
            </Select>
          </FormGroup>
          <FormGroup display="flex" flexDirection="column" marginRight="10px">
            <FormLabel
              fontFamily="'Inter',san-serif"
              fontSize="14px"
              lineHeight="17px"
              color="#2d3748"
              marginBottom="8px"
              textAlign="left"
            >
              HIPPA Signed
            </FormLabel>
            <Div display="flex" alignItems="center" marginTop="5px">
              <input
                type="checkbox"
                checked={hippaSigned}
                disabled={true}
                readOnly
                style={{ marginRight: "8px", width: "16px", height: "16px", cursor: "not-allowed" }}
              />
              <Text fontSize="12px" color="#718096">Signed HIPPA on file</Text>
            </Div>
          </FormGroup>
          <FormGroup display="flex" flexDirection="column" marginRight="10px">
            <FormLabel
              fontFamily="'Inter',san-serif"
              fontSize="14px"
              lineHeight="17px"
              color="#2d3748"
              marginBottom="8px"
              textAlign="left"
            >
              ROI Signed
            </FormLabel>
            <Div display="flex" alignItems="center" marginTop="5px">
              <input
                type="checkbox"
                checked={roiSigned}
                disabled={true}
                readOnly
                style={{ marginRight: "8px", width: "16px", height: "16px", cursor: "not-allowed" }}
              />
              <Text fontSize="12px" color="#718096">Signed ROI on file</Text>
            </Div>
          </FormGroup>
        </Display>

        <Hrline ml="-40px" mt="16px" mb="16px" />
        <Text
          fontWeight="500"
          fontSize="16px"
          marginBottom="12px"
          textAlign="left"
          color="#2D3748"
        >
          About Patient
        </Text>
        <Display display="flex" mb="20px">
          <FormGroup display="grid">
            <FormLabel
              fontFamily="'Inter',san-serif"
              fontSize="14px"
              lineHeight="17px"
              color="#2d3748"
              marginBottom="8px"
              textAlign="left"
            >
              Date of Birth{" "}
              <span style={{ color: "red", fontSize: "16px" }}>*</span>
            </FormLabel>
            <Div
              display="flex"
              position="relative"
              width="220px"
              marginRight="24px"
              alignItems="center"
            >
              <CustomDatePicker
                id="CustomDatePicker"
                width="220px"
                height="32px"
                backgroundColour="#f7f7f7"
                border={
                  dobErr ? "1px solid red" : "1px solid rgba(34,36,38,.15)"
                }
                placeholder="MM-DD-YYYY"
                value={
                  fromdate !== "" && fromdate
                    ? moment(fromdate).format("MM-DD-YYYY")
                    : ""
                } //used in application
                onChange={(e) => {
                  let d = moment(e.target.value, "YYYY-MM-DD", true).isValid();
                  setFromDate(e.target.value);
                  if (e.target.value === "") {
                    setValidDate("");
                  } else if (d) {
                    setValidDate(e.target.value);
                  }
                }}
                onClick={(e) => {
                  handlepicker(e);
                  setdobErr(false);
                }}
                onKeyPress={(event) => {
                  if (
                    !/[0-9]/.test(event.key) ||
                    event.target.value.length > 9
                  ) {
                    event.preventDefault();
                  }
                }}
                onKeyDown={(e) => keyDownExpiry(e)}
                onResultSelect={dateSelect} // state updation for picking calendar dates
                showPicker={showpicker}
                validDate={validDate} // value in date object for calendar manipulation
                closePicker={closePicker}
                max={moment(new Date(), "DD/MM/YYYY")}
              ></CustomDatePicker>
              <Imagecalendar
                id="CustomDatePicker"
                onClick={(e) => handlepicker(e)}
                src={calendar_icon_custom}
              ></Imagecalendar>
            </Div>
            {dobErr && (
              <ErrorMessage> Please Select the Date with Year</ErrorMessage>
            )}
          </FormGroup>
          <FormGroup display="flex" flexDirection="column" marginRight="24px">
            <FormLabel
              fontFamily="'Inter',san-serif"
              fontWeight="400"
              fontSize="14px"
              lineHeight="17px"
              color="#2d3748"
              marginBottom="8px"
              textAlign="left"
            >
              Age
            </FormLabel>
            <Inputbox
              type="text"
              width="220px"
              height="32px"
              background="#ffffff"
              border="1px solid #cbd5e0"
              borderRadius="4px"
              paddingLeft="12px"
              paddingRight="12px"
              value={age}
              disabled={true}
              style={{ cursor: "not-allowed", backgroundColor: "#f3f4f6" }}
            />
          </FormGroup>
          <FormGroup display="grid">
            <FormLabel
              fontFamily="'Inter',san-serif"
              fontWeight="400"
              fontSize="14px"
              lineHeight="17px"
              color="#2d3748"
              marginBottom="8px"
              textAlign="left"
            >
              Legal Sex
              <span style={{ color: "red", fontSize: "16px" }}>*</span>
            </FormLabel>
            <Select
              popupClassName="custom-blue-select"
              placeholder="Select Sex"
              value={sex1 || undefined}
              onChange={(e) => {
                setsex1(e);
                setgenderErr(false);
              }}
              style={{ width: 220, marginRight: 24, height: 32 }}
              status={genderErr ? "error" : ""}
            >
              <Option value="Male">Male</Option>
              <Option value="Female">Female</Option>
              <Option value="Prefer Not to Say">Prefer Not to Say</Option>
              <Option value="Unknown">Unknown</Option>
            </Select>
            {genderErr && (
              <ErrorMessage> Please Select your Gender</ErrorMessage>
            )}
          </FormGroup>
          <FormGroup display="grid">
            <FormLabel
              fontFamily="Inter"
              fontWeight="400"
              fontSize="14px"
              lineHeight="17px"
              color="#2d3748"
              marginBottom="8px"
              textAlign="left"
            >
              Gender Identity
            </FormLabel>
            <Select
              popupClassName="custom-blue-select"
              placeholder="Select Gender Identity"
              value={genderIdentity || undefined}
              onChange={(e) => setGenderIdentity(e)}
              style={{ width: 220, marginRight: 24, height: 32 }}
            >
              <Option value="Undefined">Undefined</Option>
              <Option value="Agender">Agender</Option>
              <Option value="Female">Female</Option>
              <Option value="Gender Fluid">Gender Fluid</Option>
              <Option value="Gender Non-conforming">Gender Non-conforming</Option>
              <Option value="Genderqueer">Genderqueer</Option>
              <Option value="Intersex">Intersex</Option>
              <Option value="Male">Male</Option>
              <Option value="Non-binary">Non-binary</Option>
              <Option value="Trans Female">Trans Female</Option>
              <Option value="Trans Male">Trans Male</Option>
              <Option value="Two Spirit">Two Spirit</Option>
              <Option value="Questioning">Questioning</Option>
              <Option value="Choose Not to Disclose">Choose Not to Disclose</Option>
              <Option value="Other">Other</Option>
            </Select>
          </FormGroup>
        </Display>
        <Display display="flex" mb="20px">
          <FormGroup display="grid">
            <FormLabel
              fontFamily="'Inter',san-serif"
              fontSize="14px"
              lineHeight="17px"
              color="#2d3748"
              marginBottom="0px"
              textAlign="left"
            >
              Marital Status{" "}
              {/* <span style={{ color: "red", fontSize: "16px" }}>*</span> */}
            </FormLabel>
            <Dropdownstyle marginTop="0px" ref={maritalNotRef}>
              <Div onClick={Toggling1}>
                <SelectInput
                  width="220px"
                  height="30px"
                  fontFamily="Inter"
                  fontWeight="400"
                  fontSize="14px"
                  lineHeight="17px"
                  letterSpacing="0.0025em"
                  color="#747474"
                  background="#FFFFFF"
                  name="marital"
                  // border="1px solid #cbd5e0"
                  border={
                    statusErr ? "1px solid red" : "1px solid rgba(34,36,38,.15)"
                  }
                  borderRadius="4px"
                  margin="0px 24px 0px 0px"
                  padding="0px 12px"
                  value={status1}
                  id="mypf_pat-mri_sta"
                >
                  {status1 || "Select Marital"}
                  <DropdownImage
                    height="7px"
                    width="10px"
                    top="11px"
                    right="10px"
                    src={arrowIcon}
                  ></DropdownImage>
                </SelectInput>
              </Div>
              {dropDown1 && MaritalStatus.length > 0 ? (
                <DropDownDiv
                  width="220px"
                  background="#FFFFFF"
                  border=" 1px solid rgba(46, 46, 46, 0.25)"
                  borderRadius="4px"
                >
                  {MaritalStatus.map((r, i) => {
                    return (
                      <DropdownOptions
                        fontSize="14px"
                        key={i}
                        value={r.title}
                        padding="7px 12px 7px 12px"
                        onClick={() => {
                          setmaritalselect(r);
                          setstatusErr(false);
                        }}
                      >
                        {r.title}
                      </DropdownOptions>
                    );
                  })}
                </DropDownDiv>
              ) : (
                ""
              )}
            </Dropdownstyle>
            {statusErr && (
              <ErrorMessage> Please Select your Status</ErrorMessage>
            )}
          </FormGroup>

          <FormGroup display="grid">
            <FormLabel
              fontFamily="Inter"
              fontWeight="400"
              fontSize="14px"
              lineHeight="17px"
              color="#2d3748"
              marginBottom="8px"
              textAlign="left"
            >
              Preferred Language
            </FormLabel>
            <Dropdownstyle marginTop="0px" ref={languageNotRef}>
              <Div onClick={Toggling2}>
                <SelectInput
                  width="220px"
                  height="30px"
                  fontFamily="Inter"
                  fontWeight="400"
                  fontSize="14px"
                  lineHeight="17px"
                  letterSpacing="0.0025em"
                  color="#747474"
                  background="#ffffff"
                  border="1px solid #cbd5e0"
                  borderRadius="4px"
                  name="language"
                  margin="0px 24px 0px 0px"
                  padding="0px 12px"
                  value={language1}
                  id="mypf_pat-lng"
                >
                  {language1 ? language1 : "Select One"}
                  <DropdownImage
                    height="7px"
                    width="10px"
                    top="11px"
                    right="10px"
                    src={arrowIcon}
                  ></DropdownImage>
                </SelectInput>
              </Div>
              {dropDown2 && LanguageLists.length > 0 ? (
                <DropDownDiv
                  width="220px"
                  background="#FFFFFF"
                  border=" 1px solid rgba(46, 46, 46, 0.25)"
                  borderRadius="4px"
                  maxHeight="225px"
                  overflowY="auto"
                  bottom="31px"
                >
                  {LanguageLists.map((r, i) => {
                    return (
                      <DropdownOptions
                        fontSize="14px"
                        key={`${i}lang`}
                        value={r.title}
                        padding="10px 12px 8px 12px"
                        onClick={() => setlanguageselect(r)}
                      >
                        {r.title}
                      </DropdownOptions>
                    );
                  })}
                </DropDownDiv>
              ) : (
                ""
              )}
            </Dropdownstyle>
          </FormGroup>
          <FormGroup display="grid">
            <FormLabel
              fontFamily="Inter"
              fontWeight="400"
              fontSize="14px"
              lineHeight="17px"
              color="#2d3748"
              marginBottom="8px"
              textAlign="left"
            >
              Race
              {/* <span style={{ color: "red", fontSize: "16px" }}>*</span> */}
            </FormLabel>
            <Dropdownstyle marginTop="0px" ref={raceNotRef}>
              <Div onClick={Toggling3}>
                <SelectInput
                  width="220px"
                  height="30px"
                  fontFamily="Inter"
                  fontWeight="400"
                  fontSize="14px"
                  lineHeight="17px"
                  letterSpacing="0.0025em"
                  color="#747474"
                  background="#ffffff"
                  // border="1px solid #cbd5e0"
                  border={
                    raceErr ? "1px solid red" : "1px solid rgba(34,36,38,.15)"
                  }
                  borderRadius="4px"
                  name="race"
                  margin="0px 24px 0px 0px"
                  padding="0px 12px"
                  value={ethnicity1}
                  id="mypf_pat-race"
                >
                  {ethnicity1 || "Select Race"}
                  <DropdownImage
                    height="7px"
                    width="10px"
                    top="11px"
                    right="10px"
                    src={arrowIcon}
                  ></DropdownImage>
                </SelectInput>
              </Div>
              {dropDown3 && RaceDetails.length > 0 ? (
                <DropDownDiv
                  width="220px"
                  background="#FFFFFF"
                  border=" 1px solid rgba(46, 46, 46, 0.25)"
                  borderRadius="4px"
                  maxHeight="225px"
                  overflowY="auto"
                  bottom="31px"
                >
                  {/* {RaceDetails.map((r, i) => {
                    return (
                      <DropdownOptions
                        fontSize="14px"
                        key={`${i}ethnicity`}
                        value={r.title}
                        padding="10px 12px 8px 12px"
                        onClick={() => {
                          setraceselect(r);
                          setraceErr(false);
                        }}
                      >
                        {r.title}
                      </DropdownOptions>
                    );
                  })} */}
                  {RaceDetails.map((r, i) => {
                    const displayTitle =
                      r.title === "Declined To Specify"
                        ? "Prefer not to say"
                        : r.title;

                    return (
                      <DropdownOptions
                        fontSize="14px"
                        key={`${i}race`}
                        value={r.title}
                        padding="10px 12px 8px 12px"
                        onClick={() => {
                          setraceselect(r);
                          setraceErr(false);
                        }}
                      >
                        {displayTitle}
                      </DropdownOptions>
                    );
                  })}
                </DropDownDiv>
              ) : (
                ""
              )}
            </Dropdownstyle>
            {raceErr && <ErrorMessage> Please Select your Race</ErrorMessage>}
          </FormGroup>

          <FormGroup display="grid">
            <FormLabel
              fontFamily="Inter"
              fontWeight="400"
              fontSize="14px"
              lineHeight="17px"
              color="#2d3748"
              marginBottom="8px"
              textAlign="left"
            >
              Ethnicity{" "}
              {/* <span style={{ color: "red", fontSize: "16px" }}>*</span> */}
            </FormLabel>
            <Dropdownstyle marginTop="0px" ref={ethinicity2NotRef}>
              <Div onClick={Toggling4}>
                <SelectInput
                  width="220px"
                  height="30px"
                  fontFamily="Inter"
                  fontWeight="400"
                  fontSize="14px"
                  lineHeight="17px"
                  letterSpacing="0.0025em"
                  color="#747474"
                  background="#ffffff"
                  // border="1px solid #cbd5e0"
                  border={
                    ethniErr ? "1px solid red" : "1px solid rgba(34,36,38,.15)"
                  }
                  borderRadius="4px"
                  name="ethnicity"
                  margin="0px 24px 0px 0px"
                  padding="0px 12px"
                  value={ethnicity2}
                  id="mypf_pat-ethn"
                >
                  {ethnicity2 || "Select Ethnicity"}
                  <DropdownImage
                    height="7px"
                    width="10px"
                    top="11px"
                    right="10px"
                    src={arrowIcon}
                  ></DropdownImage>
                </SelectInput>
              </Div>
              {dropDown4 && DropdownOptionList.length > 0 ? (
                <DropDownDiv
                  width="220px"
                  background="#FFFFFF"
                  border=" 1px solid rgba(46, 46, 46, 0.25)"
                  borderRadius="4px"
                  maxHeight="225px"
                  overflowY="auto"
                  bottom="31px"
                >
                  {DropdownOptionList.map((r, i) => {
                    return (
                      <DropdownOptions
                        fontSize="14px"
                        key={`${i}ethnicity`}
                        value={r.title}
                        padding="10px 12px 8px 12px"
                        onClick={() => {
                          setethinicityselect(r);
                          setethniErr(false);
                        }}
                      >
                        {r.title}
                      </DropdownOptions>
                    );
                  })}
                </DropDownDiv>
              ) : (
                ""
              )}
            </Dropdownstyle>
            {ethniErr && (
              <ErrorMessage> Please Select your Ethnicity</ErrorMessage>
            )}
          </FormGroup>

        </Display>
        <Display display="flex" mb="20px">
          <FormGroup display="grid">
            <FormLabel
              fontFamily="Inter"
              fontWeight="400"
              fontSize="14px"
              lineHeight="17px"
              color="#2d3748"
              marginBottom="8px"
              textAlign="left"
            >
              Pronoun
            </FormLabel>
            <Select
              popupClassName="custom-blue-select"
              placeholder="Select Pronoun"
              value={pronoun || undefined}
              onChange={(e) => setPronoun(e)}
              style={{ width: 220, marginRight: 24, height: 32 }}
            >
              <Option value="He/Him">He/Him</Option>
              <Option value="She/Her">She/Her</Option>
              <Option value="They/Them">They/Them</Option>
              <Option value="Ze/Zir">Ze/Zir</Option>
              <Option value="Xe/Xem">Xe/Xem</Option>
              <Option value="Prefer Not to Disclose">Prefer Not to Disclose</Option>
              <Option value="Others">Others</Option>
            </Select>
          </FormGroup>
          <FormGroup display="grid">
            <FormLabel
              fontFamily="Inter"
              fontWeight="400"
              fontSize="14px"
              lineHeight="17px"
              color="#2d3748"
              marginBottom="8px"
              textAlign="left"
            >
              Sexual Orientation
            </FormLabel>
            <Select
              popupClassName="custom-blue-select"
              placeholder="Select Sexual Orientation"
              value={sexualOrientation || undefined}
              onChange={(e) => setSexualOrientation(e)}
              style={{ width: 220, marginRight: 24, height: 32 }}
            >
              <Option value="Undefined">Undefined</Option>
              <Option value="Asexual">Asexual</Option>
              <Option value="Bisexual">Bisexual</Option>
              <Option value="Gay">Gay</Option>
              <Option value="Heterosexual">Heterosexual</Option>
              <Option value="Lesbian">Lesbian</Option>
              <Option value="Pansexual">Pansexual</Option>
              <Option value="Polysexual">Polysexual</Option>
              <Option value="Queer">Queer</Option>
              <Option value="Questioning">Questioning</Option>
              <Option value="Choose not to Disclose">Choose not to Disclose</Option>
              <Option value="Other">Other</Option>
            </Select>
          </FormGroup>
          <FormGroup display="grid">
            <FormLabel
              fontFamily="Inter"
              fontWeight="400"
              fontSize="14px"
              lineHeight="17px"
              color="#2d3748"
              marginBottom="8px"
              textAlign="left"
            >
              Religious Affiliation
            </FormLabel>
            <Select
              popupClassName="custom-blue-select"
              placeholder="Select Affiliation"
              value={religiousAffiliation || undefined}
              onChange={(e) => setReligiousAffiliation(e)}
              style={{ width: 220, marginRight: 24, height: 32 }}
            >
              <Option value="None">None</Option>
              <Option value="Adventist">Adventist</Option>
              <Option value="African Religions">African Religions</Option>
              <Option value="Afro-Caribbean Religions">Afro-Caribbean Religions</Option>
              <Option value="Agnosticism">Agnosticism</Option>
              <Option value="Anglican">Anglican</Option>
              <Option value="Animism">Animism</Option>
              <Option value="Assembly of God">Assembly of God</Option>
              <Option value="Babi & Baha'i faiths">Babi & Baha'i faiths</Option>
              <Option value="Baptist">Baptist</Option>
              <Option value="Bon">Bon</Option>
              <Option value="Brethren">Brethren</Option>
              <Option value="Buddhism">Buddhism</Option>
              <Option value="Catholic">Catholic</Option>
              <Option value="Christian">Christian</Option>
              <Option value="Christian Science">Christian Science</Option>
              <Option value="Church of Christ">Church of Christ</Option>
              <Option value="Church of God">Church of God</Option>
              <Option value="Congregational">Congregational</Option>
              <Option value="Episcopal">Episcopal</Option>
              <Option value="Evangelical">Evangelical</Option>
              <Option value="Greek Orthodox">Greek Orthodox</Option>
              <Option value="Hinduism">Hinduism</Option>
              <Option value="Islam">Islam</Option>
              <Option value="Jainism">Jainism</Option>
              <Option value="Jehovah's Witness">Jehovah's Witness</Option>
              <Option value="Judaism">Judaism</Option>
              <Option value="Lutheran">Lutheran</Option>
              <Option value="Mennonite">Mennonite</Option>
              <Option value="Methodist">Methodist</Option>
              <Option value="Mormon (Latter-day Saints)">Mormon (Latter-day Saints)</Option>
              <Option value="Muslim">Muslim</Option>
              <Option value="Native American Spirituality">Native American Spirituality</Option>
              <Option value="Nazarene">Nazarene</Option>
              <Option value="Orthodox Christian">Orthodox Christian</Option>
              <Option value="Pentecostal">Pentecostal</Option>
              <Option value="Presbyterian">Presbyterian</Option>
              <Option value="Protestant">Protestant</Option>
              <Option value="Quaker">Quaker</Option>
              <Option value="Reformed">Reformed</Option>
              <Option value="Roman Catholic">Roman Catholic</Option>
              <Option value="Seventh-day Adventist">Seventh-day Adventist</Option>
              <Option value="Shinto">Shinto</Option>
              <Option value="Sikhism">Sikhism</Option>
              <Option value="Taoism">Taoism</Option>
              <Option value="Unitarian Universalist">Unitarian Universalist</Option>
              <Option value="Unity">Unity</Option>
              <Option value="Wicca">Wicca</Option>
              <Option value="Zoroastrianism">Zoroastrianism</Option>
              <Option value="Other">Other</Option>
              <Option value="Prefer Not to Answer">Prefer Not to Answer</Option>
            </Select>
          </FormGroup>
          <FormGroup display="grid">
            <FormLabel
              fontFamily="Inter"
              fontWeight="400"
              fontSize="14px"
              lineHeight="17px"
              color="#2d3748"
              marginBottom="14px"
              textAlign="left"
            >
              Interpreter Required
            </FormLabel>
            <div style={{ justifySelf: "flex-start" }}>
              <Switch
                checked={interpreterRequired}
                onChange={(checked) => setInterpreterRequired(checked)}
              />
            </div>
          </FormGroup>
        </Display>
        <Display display="flex" mb="20px">
          <FormGroup display="grid">
            <FormLabel
              fontFamily="Inter"
              fontWeight="400"
              fontSize="14px"
              lineHeight="17px"
              color="#2d3748"
              marginBottom="8px"
              textAlign="left"
            >
              Annual Family Income
            </FormLabel>
            <Inputbox
              type="text"
              width="220px"
              height="32px"
              background="#ffffff"
              border="1px solid #cbd5e0"
              borderRadius="4px"
              paddingLeft="12px"
              paddingRight="12px"
              value={annualFamilyIncome}
              onChange={(e) => {
                const val = e.target.value;
                if (val === "" || /^[^a-zA-Z]+$/.test(val)) {
                  setAnnualFamilyIncome(val);
                }
              }}
            />
          </FormGroup>
        </Display>

        <Hrline ml="-40px" mt="0px" mb="20px" />
        <Display display="flex" pb="20px">
          <Button
            padding="8px 16px"
            height="32px"
            border=" 1px solid #2C7BE5"
            background=" #FFF"
            hoverBackColor="rgba(244, 246, 249, 0.75)"
            borderRadius="4px"
            fontFamily="'Inter',san-serif"
            fontWeight="500"
            lineHeight="17px"
            color="#2C7BE5"
            marginRight="20px"
            className="close_active"
            onClick={CancelPage}
          >
            Cancel
          </Button>
          <Button
            padding="7px 32px 9px 32px"
            height="32px"
            background="#2C7BE5"
            hoverBackColor="#005FB2"
            borderRadius="4px"
            fontFamily="'Inter',san-serif"
            fontWeight="500"
            lineHeight="17px"
            disabled={(showsave || holdSave) && true}
            color="#ffffff"
            border="none"
            className="save_active"
            title={holdSave ? "Please Wait while validating your mail" : ""}
            onClick={OnSubmit}
            id="edPr_btn-sv"
          >
            {showsave ? "Waiting For Review" : "Save"}
          </Button>
        </Display>
      </Form>

      <Modal width="100%" height="100%" show={showpop1}>
        <ModalContainer justifyContent="center" alignItems="flex-start">
          <ModalDialog width="377px">
            <ModalHeader
              padding="20px 20px"
              borderLess
              justifyContent="space-between"
            >
              <ModalTitle
                lineHight="16px"
                fontSize="18px"
                fontWeight="400"
                color="#2E2C34"
                fontFamily="'Inter',Sans-Serif"
              >
                Deleting avatar. Continue?
              </ModalTitle>
            </ModalHeader>
            <ModalBody
              padding="0px 20px 20px 20px"
              lineHight="16px"
              fontSize="16px"
              fontWeight="400"
              color="#6A6A6A"
              fontFamily="'Inter',Sans-Serif"
            >
              Deleting avatar. Continue?
            </ModalBody>
            <ModalFooter padding="0px 20px 20px 20px" borderTop="none">
              <Div display="flex" justifyContent="flex-end" alignItems="center">
                <Button
                  padding="8px 16px"
                  height="32px"
                  background="#FFFFFF"
                  border="1px solid #2C7BE5"
                  borderRadius="4px"
                  fontFamily="'Work Sans',sans-serif"
                  fontWeight="500"
                  lineHeight="17px"
                  color="#2C7BE5"
                  marginRight="20px"
                  fontSize="16px"
                  className="close_active"
                  onClick={() => {
                    Setshowpop1(false);
                  }}
                >
                  Cancel
                </Button>
                <Button
                  padding="7px 32px 9px 32px"
                  height="32px"
                  background="#2C7BE5"
                  hoverBackColor="#005FB2"
                  borderRadius="4px"
                  fontFamily="'Work Sans',sans-serif"
                  fontWeight="500"
                  lineHeight="17px"
                  color="#FFFFFF"
                  border="none"
                  fontSize="16px"
                  className="save_active"
                  onClick={RemoveProfilePicture}
                >
                  Ok
                </Button>
              </Div>
            </ModalFooter>
          </ModalDialog>
        </ModalContainer>
      </Modal>

      <Modal width="100%" height="100%" show={show}>
        <ModalContainer justifyContent="center" alignItems="center">
          <ModalDialog animation={ModalAnimat} padding="32px" width="414px">
            <Div
              display="flex"
              justifyContent="space-between"
              alignItems="center"
            >
              <ModalTitle
                lineHight="27px"
                fontSize="20px"
                fontWeight="600"
                color="#0a1629"
              >
                Upload Picture
              </ModalTitle>

              <BsXLg
                style={{
                  color: "#407BFF",
                  cursor: "pointer",
                  height: "14px",
                  width: "14px",
                }}
                onClick={closepopup}
              />
            </Div>

            <DragDrop padding={previewimg ? "0px" : "20px 20px 24px"}>
              {!previewimg && (
                <Text
                  fontSize="16px"
                  lineHeight=" 22px"
                  color="#263446"
                  marginBottom="20px"
                  mt="20px"
                  id="dropContainer"
                  style={{ border: "1px solid black;height:100px" }}
                >
                  Drag &amp; Drop
                </Text>
              )}
              {previewimg ? (
                <ReactCrop
                  src={previewimg}
                  crop={crop}
                  ruleOfThirds
                  onImageLoaded={(imageRef) => setImageRef(imageRef)}
                  onComplete={(crop) => makeClientCrop(crop)}
                  onChange={(crop) => SetCrop(crop)}
                  crossorigin="anonymous"
                />
              ) : (
                <Image
                  loading="lazy"
                  width="45px"
                  margin="0px auto 0px auto"
                  src={UploadFile1}
                />
              )}
              {!previewimg && (
                <>
                  <FileInput
                    ref={fileInputRef}
                    type="file"
                    id="fileInput"
                    multiple
                    onChange={(e) => FileHandleChange(e)}
                    accept=".png, .jpg, .jpeg"
                  />
                  <Text
                    fontSize="12px"
                    color="#7d8592"
                    marginBottom="20px"
                    mt="30px"
                    textAlign="center"
                  >
                    JPG,PNG or JPEG Smaller than 2 MB or browse for a file to
                    upload
                  </Text>
                  <Div
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                    backColor="#fafafa"
                    mb="20px"
                  >
                    <Button
                      padding="12px 20px"
                      borderRadius="8px"
                      background="#407BFF"
                      hoverBackColor="#2C7BE5"
                      fontWeight="500"
                      lineHeight="16px"
                      fontSize="16px"
                      color="#FFFFFF"
                      border="none"
                      onClick={openFilePicker}
                      type="button"
                    >
                      Choose File
                    </Button>
                  </Div>
                </>
              )}
            </DragDrop>

            <ModalFooter marginTop="20px" borderTop="none">
              <Div display="flex" justifyContent="flex-end" alignItems="center">
                <Button
                  padding="8px 16px"
                  height="32px"
                  borderRadius="4px"
                  color=" #2C7BE5"
                  border=" 1px solid #2C7BE5"
                  background=" #FFF"
                  hoverBackColor="rgba(244, 246, 249, 0.75)"
                  fontFamily="'Work Sans',sans-serif"
                  fontWeight="500"
                  lineHeight="17px"
                  marginRight="20px"
                  fontSize="16px"
                  className="close_active"
                  onClick={popclsbtn}
                >
                  Cancel
                </Button>
                <Button
                  padding="7px 32px 9px 32px"
                  height="32px"
                  background="#2C7BE5"
                  hoverBackColor="#005FB2"
                  borderRadius="4px"
                  fontFamily="'Work Sans',sans-serif"
                  fontWeight="500"
                  lineHeight="17px"
                  color="#FFFFFF"
                  border="none"
                  fontSize="16px"
                  className="save_active"
                  onClick={getcropimage}
                >
                  Ok
                </Button>
              </Div>
            </ModalFooter>
          </ModalDialog>
        </ModalContainer>
      </Modal>
    </>
  );
};

export default EditProfile;
